import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import GridControl from '../components/Controls/gridControl.js';
import DispatchMainToolbar from '../components/Dispatch/DispatchMainToolbar.js';
import '../assets/Styles/DispatchCSS/DispatchCSS.css'; // Import Bootstrap CSS
import APICom from "../utils/helpers/APICom";
import CancelTrip from '../components/Dispatch/CancelTrip.js';
import { useDispatch, useSelector } from "react-redux";
import {Col, Container, Modal, Row, Form, Spinner, Button } from 'react-bootstrap';
import MapControl from '../components/Controls/mapControl.js';
import TripActions from '../components/Dispatch/TripActionsDialog.js';
import ActivateTrip from '../components/Dispatch/ActivateTrip.js';
// import EditTrip from '../components/Dispatch/EditTrip.js';
import DriverActionsDialog from '../components/Dispatch/DriverActions/DriverActionsDialog.js';
import GroupingActions from '../components/Dispatch/GroupingAction.js';
import BuildCluster from '../components/Dispatch/BuildCluster.js';
import VehicleTracking from '../components/Dispatch/VehicleTracking.js';
import UpdateCallback from '../components/Dispatch/UpdateCallback.js';
import TripHistoryDialog from '../components/Dispatch/TripHistory/TripHistoryDialog.js';
import ConfirmationModal from '../components/Controls/ConfirmationModal.js';
import ARBResponseListener from '../components/Controls/ARBResponseListener.js';
import BrokerActionsDialog from'../components/Dispatch/BrokerActions/BrokerActionsDialog.js';
import AgileDispatch from'../components/Dispatch/AgileDispatch.js';
import * as XLSX from 'xlsx';
import saveIcon from "../assets/Images/CommonImages/save.png";
import MultiSelectDropdown from '../components/Controls/multiselectdropdown.js';
import clearFilterIcon from "../assets/Images/CommonImages/clearFilter.png";
import refreshIcon from "../assets/Images/CommonImages/refresh.png";
import deSelectIcon from "../assets/Images/CommonImages/deselect.png";
import selectAllIcon from "../assets/Images/CommonImages/selectAll.png";
import collapseIcon from "../assets/Images/CommonImages/collapseGroup.png";
import expandIcon from "../assets/Images/CommonImages/expandGroup.png";
import infoIcon from "../assets/Images/CommonImages/info.png";
import AdjustTimes from "../assets/Images/CommonImages/adjustTimes.png";
import CommitTimes from "../assets/Images/CommonImages/commitTimes.png";
import arrowUp from "../assets/Images/MapImages/arrowUp.png";
import arrowDown from "../assets/Images/MapImages/arrowDown.png";
import TripDetailsDialog from '../components/Dispatch/TripDetailsDialog.js';
import MTDiagnostic from '../components/Dispatch/MTDiagnosticDialog.js'
import BuildManifest from '../components/Dispatch/BuildManifest.js';
import ShowRoutes from '../components/Dispatch/ShowRoutes.js';
import RBSProcess from '../components/Dispatch/RBSProcess.js';
import StandingRoutes from '../components/Dispatch/StandingRoutes.js';
import ColumnChooser from '../components/Controls/ColumnChooser.js';
import CommonFunctions from '../utils/helpers/CommonFunctions.js';
import ValidateIcon from "../assets/Images/CommonImages/validateIcon.png";
import AddBreakModal from '../components/Dispatch/AddBreak.js';
import AgentNotesDialog from'../components/Dispatch/AgentNotes/AgentNotesDialog.js';
import moment from 'moment';
import ModuleSecurity from '../utils/helpers/ModuleSecurity.js';
import { useNavigate } from "react-router-dom";
import RouteSuggestion from "../components/Dispatch/RouteSuggestion.js";
import Route from "../components/Dispatch/RoutingActions/Route.js";
import PersistStorage from '../utils/helpers/PersistStorage.js';
import RunRouteSuggestion from "../components/Dispatch/RoutingActions/RunRouteSuggestion.js";

const DispatchComponent = ({sendAffToParent, gridRowData}) => {
    const { StopViewBreakTrip} = useSelector((store) => store.ARB);

    let CONTEXT_MENU_LABELS = {
        CANCEL: "Cancel",
        ACTIVATE: "Activate",
        ASSIGN: "Assign",
        TRIP_ACTIONS: "Trip Actions",
        SEGMENTFARE: "Segment Fare",
        TRIP_HISTORY: "Trip History",
        TRIP_CLUSTER: "Cluster",
        TRIP_GROUP: "Group",
        TRIP_BROKER: "Broker",
        AGILE_DISPATCH: "Agile Dispatch",
        TRIP_MANIFEST: "Build Manifest",
        ADD_ROUTE: "Add to Route",
        ADD_CLUSTER: "Add to Cluster",
        TRIP_DETAILS : "Trip Details",
        UNROUTE: "UnRoute",
        UNASSIGN: "UnAssign",
        Rider_Notes: "Rider Notes",
        ROUTE_SUGGESTIONS: "Route Suggestions",
        MARK_WILLCALL: "Mark As WillCall"
    }
    let CONTEXT_MENU_LABELS_FOR_STOP_VIEW = {
        UNROUTE: "UnRoute",
        // ADJUSTROUTESTARTTIME: "Adj. Route StartTime",
        UPDATESCHEDULETIME: "Update Sch Time"
    }
    const [handlePageProgressBar, sethandlePageProgressBar] = useState(null);
    const _vManifestNumber = useRef(0);
    const _iAffilaiteID = useRef(0);
    const [showAlert, setAlert] = useState(false);
    const [routeObj, setAlertObj] = useState({ alertTitle: '', alertMsg: '' , displayFooter: true});
    const dispatch = useDispatch();
    const { SessionPersistData } = useSelector((store) => store.apicommunication);
    const { loginData } = useSelector((store) => store.login);
    const { GlobalASCSData, DispatchVehicleData, DispatchDriverData, ZoneVerticesData, DispatchGridColorsData, BrokerServingAffiliatesData, AttributeData, AffiliateData} = useSelector((store) => store.combinedata);
    const [showModal, setShowModal] = useState(false);
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [DispatchScreenModalProps, setDispatchScreenModalProps] = useState({"show": true, "Title":"", "Body":"", "btnCanceText":"", "btnOkText":"","ShowCancelButton":false });
    const [DispatchGridResponse, setDispatchGridResponse] = useState({});
    const [ClusterGridResponse, setClusterGridResponse] = useState({});
    const [ClusterGridColumnSetting, setClusterGridColumnSetting] = useState({});
    const [showCancel, setShowCancel] = useState(false);
    const [mapView, setMapView] = useState(false);
    const [width, setWidth] = useState(100);
    const [showTripActionsDialog, setShowTripActionsDialog] = useState(false);
    const [showActivateDialog, setShowActivateDialog] = useState(false);
    // const [showEditDialog, setShowEditDialog] = useState(false);
    const [showDriverActionsDialog, setDriverActionsDialog] = useState(false);
    const [showGroupingDialog, setShowGroupingActionDialog] = useState(false);
    const [showClusteringDialog, setShowClusterDialog] = useState(false);
    const [selectRowData, setSelectedRowData] = useState([]);
    const [selectRowDataForStopView, setSelectedRowDataForStopView] = useState([]);
    const [bCalledFromStopView, setbCalledFromStopView] = useState(false);
    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const [selectedManifest, setselectedManifest] = useState("");
    const [ShowGridClusterLoader, setShowGridClusterLoader] = useState(false);
    const [MapDetailData, setMapDetailData] = useState([]);
    const [SelectedStopsData, setSelectedStopsData] = useState([]);
    const [showColumnChooser, setShowColumnChooser] = useState(false);
    const [vehData, setVehData] = useState([]);
    const [apiRowData, setApiRowData] = useState([]);//DispatchGridColorsData[0]
    const [apiColData, setApiColData] = useState(DispatchGridColorsData[1]);
    const [apiAttributesColors, setApiAttributesColors] = useState(DispatchGridColorsData[2]);
    const [DynamicsStyles, setDynamicsStyles] = useState("");
    const [showVehicleTracking, setShowVehicleTracking] = useState(false);
    const [showUpdateCallback, setShowUpdateCallback] = useState(false);
    const [showTripHistoryDialog, setTripHistoryDialog] = useState(false);
    const [showBrokerActionsDialog, setBrokerActionsDialog] = useState(false);
    const [showAgileDispatch, setShowAgileDispatch] = useState(false);
    const [addTripToRoute, setAddTripToRoute] = useState(false);
    const [addTripToRouteCluster, setAddTripToRouteCluster] = useState(false);
    const [groupingHeaderFilter, setGroupingHeaderFilter] = useState("No Column Grouping");
    const [arbProgress, setarbProgress] = useState(100);
    const [route, setRoute] = useState("");
    const [tableSelRows, setTableRowsSel] = useState([]);
    const [showTripDetailsDialog, setTripDetailsDialog] = useState(false);
    const [showMTDiagnosticDialog, setMTDiagnosticDialog] = useState(false);
    const [SelectedRoute, setSelectedRoute] = useState("");
    const [showManifestBuildDialog, setManifestBuildDialog] = useState(false);
    const [showRBSProcessDialog, setRBSProcessDialog] = useState(false);
    const [showStandingRouteDialog, setStandingRouteDialog] = useState(false);
    const [showRoutesDialog, setShowRoutesDialog] = useState(false);
    const [arrangedClusterTrips, setArrangedClusterTrips] = useState([]);
    const [showClusterGridLoader, setClusterGridLoader] = useState(false);
    const [rowReArrangeCheck, setRowReArrangeCheck] = useState(false);
    const [showCompletedTrips, setShowCompletedTrips] = useState(false);
    const [nullifyActivated, setNullifyActivated] = useState(false);
    const [showAddBreakModal, setAddBreakModal] = useState(false);
    const [showEditRouteTimeModal, setEditRouteTimeModal] = useState(false);
    const [routeStartTime, setRouteStartTime] = useState("");
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [triggerUnAssign, setTriggerUnAssign] = useState(false);
    const [triggerUnRoute, setTriggerUnRoute] = useState(false);
    const [triggerRouteSuggestion, settriggerRouteSuggestion] = useState(false);
    const [violationColors, setViolationColors] = useState([{"capacity":"#FFA500", "timeWindow":"#C6B0F2", "RideTime":"#87CEEB", 
        "maxMilesHours":"#BF8B19", "driverBreak":"#91F895",
        "uniqueStops":"#FA7AFC", "nonDrop":"#FF0000", "puLoopBack":"#F5CAA4","WillCallTrip":"#B2B200","TripStartTime":"#004d80",
        "MaxTrips":"#00ff3e","invalidDOGPS":"#000dff","maxRouteHrs":"#303030","invalidPUGPS":"#05501e", "RideSharing":"#5d00ff"}
    ]);
    const [isResizing, setIsResizing] = useState(false);
    const [modalBodyHTML, setModalBodyHTML] = useState("");
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBtnHTML, setModalBtnHTML] = useState([]);
    const [clusterTripSelection, setClusterTripSelection] = useState({Number: "", Type: ""});
    const routedTripShow = useRef({"route":"","data":""});
    const unroutedTripShow = useRef({"unroutedTripConf":"","data":""});
    const RefSelectedDate = useRef();
    const ClusterTableObject = useRef(null);
    const DispatchTableObject = useRef(null);
    const mainTableObj = useRef(null);
    const mapViewCheck = useRef(null);
    const sidebarCheck = useRef(false);
    const manifestDataReceivedCheckRef = useRef(false);
    const selectedTripInfo = useRef(null);
    const selectedTripInfoToRefreshGrid = useRef(null);
    const DropDownRouteValue = useRef(null);
    const checkboxSelectionFlag = useRef(false);
    const groupingFilterCheck = useRef("No Column Grouping");
    const { ARBResponseForStopViewComputeEstimates, ARBResponseForStopViewValidate} = useSelector((store) => store.ARB);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Manual Route Adjustment',
    body:'Changes Saved Sucessfully', btnCancelText: 'No',
    btnOkText: 'Yes'});
    const [showAgentNotesDialog, setAgentNotesDialog] = useState(false);
    const [clusterTableStateBeforeCompute, setclusterTableStateBeforeCompute] = useState(null);
    const navigate = useNavigate();
    const [force_assign, setforce_assign] = useState(false);
    const [showRouteActionCreate, setRouteActionCreate] = useState(false);
    const [isCreateNew, setIsCreateNew] = useState(true);
    const [routeAlertObj, setRouteAlertObj] = useState({ alertTitle: '', alertMsg: '' });
    const [showRouteAlert, setRouteAlert] = useState(false);
    const [disableAllButtons, setdisableAllButtons] = useState(false);
    const [showRouteSuggestionActionCreate, setRouteSuggestionActionCreate] = useState(false);
    const [rowMoveFlag, setRowMoveFlag] = useState(false);
    const someThingChangedInGrid = useRef(true);
    const [modalActionType, setModalActionType] = useState(null);
    const [StopViewSelectedRowIndex, setStopViewSelectedRowIndex] = useState(0);
    const SelectedRowRefID = useRef('');
    const [SelectedRowStopType, setSelectedRowStopType] = useState(0)
    const [validationError, setValidationError] = useState(false);
    const [errorMessageUST, setErrorMessageUST] = useState('');
    const HistoryReason = useRef('');
    const ClusterGridSelectedRows = useRef([]);
    const ClusterGridSrollVertical = useRef(0);
    const ClusterGridDataResetComplete = useRef(false);
    const [GridRefreshPaused, setGridRefreshPaused] = useState(false);
    const [MapViewFromDoubleClick, setMapViewFromDoubleClick] = useState(true);

    if(!ModuleSecurity.CheckModuleSecurityByTag("DSPC")){
        alert("You do not have access rights to access this section. Please contact the administrator.");
        navigate('/Login');
    }

    // Stop View Grid 
    let ContextMenuStopView = [
        // {
        //     label:CONTEXT_MENU_LABELS_FOR_STOP_VIEW.ADJUSTROUTESTARTTIME,
        //     action:function(e, row){
        //         setEditRouteTimeModal(true);
        //         setModalActionType('adjustRouteStartTime'); // Set action type
        //         let StopViewMainData = ClusterTableObject.current.getData()[0];
        //         setRouteStartTime (StopViewMainData.SchTime);
        //     }
        // },
        {
            label:CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UPDATESCHEDULETIME,
            action:function(e, row){
                let allSelectedRows = ClusterTableObject.current.getSelectedRows();
                if (Array.isArray(allSelectedRows) && allSelectedRows.length > 1) {
                    setAlertObj({ ...routeObj, alertTitle: 'Update Schedule Time', alertMsg: 'Please select a single stop to update the schedule time.' , displayFooter: true});
                    setAlert(true);
                    return; // Exit the function to prevent further execution
                    
                }

                else{
                    let StopViewSelectedRow = row.getData(); // Get the selected row's data
                    if(StopViewSelectedRow.Type === "IdleTime"){
                        setAlertObj({ ...routeObj, alertTitle: 'Update Schedule Time', alertMsg: 'Updating schedule time is not allowed for idle stops.' , displayFooter: true});
                        setAlert(true);
                        return; // Exit the function to prevent further execution

                    }
                    else if(StopViewSelectedRow.Type === "StartDept" || StopViewSelectedRow.Type === "EndDept" || StopViewSelectedRow.PUPerson === "SDepot" 
                        || StopViewSelectedRow.PUPerson === "EDepot"){
                        setAlertObj({ ...routeObj, alertTitle: 'Update Schedule Time', alertMsg: 'Updating schedule time is not allowed for depot stops.' , displayFooter: true});
                        setAlert(true);
                        return; // Exit the function to prevent further execution

                    }

                    else if(StopViewSelectedRow.PUPerson === "BreakTrip"){
                        setAlertObj({ ...routeObj, alertTitle: 'Update Schedule Time', alertMsg: 'Updating schedule time is not allowed for break stops.' , displayFooter: true});
                        setAlert(true);
                        return; // Exit the function to prevent further execution

                    }

                    else if(StopViewSelectedRow.bPerformed === true){
                        setAlertObj({ ...routeObj, alertTitle: 'Update Schedule Time', alertMsg: 'Updating schedule time is not allowed for performed stops.' , displayFooter: true});
                        setAlert(true);
                        return; // Exit the function to prevent further execution

                    }

                    
                    else{
                        setEditRouteTimeModal(true);
                        setModalActionType('updateScheduleTime'); // Set action type  
                        setStopViewSelectedRowIndex(StopViewSelectedRow.Index)
                        SelectedRowRefID.current = StopViewSelectedRow.TripNo;
                        setSelectedRowStopType(StopViewSelectedRow.Type)
                        setRouteStartTime (StopViewSelectedRow.SchTime);

                    }
                    
                }
                
            }
        },
        {
            label:CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UNROUTE,
            action: async function (e, row){
               
                let clusterComparisonTypeID = ['10','11','12','13','14','15','16','17','18','22','23','24'];
                let vManifestNumber = row.getData().ManifestNumber;
                let CDFTypeID = row.getData().ClusterTypeID;
                let PUPerson = row.getData().PUPerson;
                let iAffiliateID = row.getData().iAffiliateID;
                _vManifestNumber.current = vManifestNumber;
                _iAffilaiteID.current = iAffiliateID;

                if(PUPerson == 'BreakTrip'){
                    PerformReRouting(row);
                }
                else if(PUPerson != 'SDepot' && PUPerson != 'EDepot'){
                    if(clusterComparisonTypeID.includes(CDFTypeID)){
                        UnRouteActions();
                    }
                    else{
                        UnRouteActions();
                    }
                }
                else{
                    setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'UnRouting', body:'Please Select the Service Trip!!!', btnCancelText: 'No', btnOkText: 'Ok'}));
                }
            }
        },
    ]    
    
    function filterUniqueTrips(tripArray) {
        const seen = new Set(); 
        return tripArray.filter(trip => {
            if (!seen.has(trip.TripNo)) {
                seen.add(trip.TripNo);
                return true;
            }
            return false;
        });
    }

    const UnRouteActions = async() =>{
        try{
            sethandlePageProgressBar("dispatch")
            let uniqueTrips = ClusterTableObject.current.getSelectedData();
            const selectedGridData = filterUniqueTrips(uniqueTrips);
            const affID = selectedGridData[0].iAffiliateID;
            let callBackURL = "";
            const SelectedRecordsForARB = [];
            if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                const jsonArray = GlobalASCSData;
                const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
                callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
            }
            let bschedule = "";
            for (let k = 0; k < selectedGridData.length; k++) {
                if (selectedGridData[k].Route !== "" && selectedGridData[k].PickupPerson != 'BreakTrip' &&  selectedGridData[k].PickupPerson != 'SDepot' &&  selectedGridData[k].PickupPerson != 'EDepot') {
                    bschedule = (typeof selectedGridData[k].bIsScheduled === "boolean" ? (selectedGridData[k].bIsScheduled === true ? true:false):(selectedGridData[k].bIsScheduled.toUpperCase() === "TRUE" ? true : false));
                    SelectedRecordsForARB.push({
                        PickupDateTime: selectedGridData[0].ReqTimeHidden,
                        AffiliateID: selectedGridData[k].iAffiliateID,
                        ServiceID: (!bschedule?selectedGridData[k].iServiceID:-1),
                        ScheduleID: (bschedule?selectedGridData[k].iScheduleID:-1),
                        Confirmation: selectedGridData[k].TripNo,
                        vManifestNumber: selectedGridData[k].ManifestNumber,
                        TripRequestStatus: selectedGridData[k].StopStatus,
                        iAssignedVehicleId: selectedGridData[k].iVehicleID === "" ? "-1" : selectedGridData[k].iVehicleID,
                        iAssignedDriverId: "-1"//selectedGridData[k].AssignedDriverId === "" ? "-1" : selectedGridData[k].AssignedDriverId,
                    });
                }
            }

            if (SelectedRecordsForARB.length === 0) {
                setAlertObj({ ...routeObj, alertTitle: 'UnRoute', alertMsg: 'No grouped record is selected. Please select valid grouped record(s) to perform this action!' , displayFooter: true});
                setAlert(true);
                return false;
            }

            UnRouteTrips(affID, callBackURL, SelectedRecordsForARB);
        }
        catch(err){console.log(err);}
    }

    const UnRouteTrips = async (affID, cbURL, arrObj) => {
        let Param = {
            "affiliate_id": affID,
            "requested_page_name": "UnClusteringAction",
            "user_id": loginData.iUserID,
            "app_id": 26,
            "object_list": JSON.stringify(arrObj),
            "call_back_url": cbURL
        }
        setAlertObj({ ...routeObj, alertTitle: 'Initializing UnRouting Process', alertMsg: 'Please Wait...' , displayFooter: false});
        setAlert(true); 
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UnRoute", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if (result.run_id > 0) {
            setAlertObj({ ...routeObj, alertTitle: 'UnRouting Started', alertMsg: 'UnRouting is being performed...' , displayFooter: false});
            setAlert(true);
        }
        else if (result.error_message !== null && result.error_message !== "") {
            setAlertObj({ ...routeObj, alertTitle: 'Un-Route', alertMsg: result.error_message , displayFooter: true});
            setAlert(true);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();
        }
        else {
            setAlertObj({ ...routeObj, alertTitle: 'Un-Route', alertMsg: 'Something went wrong !!!' , displayFooter: true});
            setAlert(true);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();
        }
    }
    const PerformReRouting = async (row) =>{
        setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...' , displayFooter: false});
        setAlert(true);

        let PickupDateTime = row.getData().ReqTimeHidden;
        let iServiceID = row.getData().iServiceID;
        let PUPerson = row.getData().PUPerson;
        let vManifestNumber = row.getData().ManifestNumber;
        let iAffiliateID = row.getData().iAffiliateID;
        if(PUPerson == 'BreakTrip'){
           let params = {
            "vServiceIDs":String(iServiceID),
            "vScheduleIDs":String(-1),
            "dtSelectedDate": PickupDateTime,
            "iUserID": loginData.iUserID
            }
            
            setShowGridClusterLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/ReRoute", "post", { "Content-Type": "application/json" }, params,  null);
            setAlert(false);
            if(response.data[0].Result  == 1){
                setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Re-Routing', body:'BreakTrip is Deleted Successfully', btnCancelText: 'No', btnOkText: 'Ok'})); 
                StopViewGridLoad(vManifestNumber, iAffiliateID);
            }
            else if(response.data[0].Result   == -1){
                setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Re-Routing', body:'BreakTrip Cannot Deleted', btnCancelText: 'No', btnOkText: 'Ok'}));
            }
        }
    }
    //Main Dispatch Grid
    let ContextMenuArray = [
        {
            label:CONTEXT_MENU_LABELS.CANCEL,
            action:function(e, row){
                setShowCancel(true);
                // row.update({name:"Steve Bobberson"});
            }
        },
        
        {
            label:CONTEXT_MENU_LABELS.ACTIVATE,
            action:function(e, row){
                setShowActivateDialog(true);
                // row.select();
            }
        },
        {
            separator:true,
        },
        {
            label:CONTEXT_MENU_LABELS.MARK_WILLCALL,
            action:function(e, row){
                let rowData = row.getData();
                let selectedRow = mainTableObj.current.getSelectedRows();
                let modalBtn = 
                <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                    {"OK"}
                </Button>;
                if(selectedRow.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to mark will call."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                {
                    if(rowData.Route && rowData.Route !== "")
                    {
                        setModalHeaderText("Trip Status Alert");
                        setModalBodyHTML("The trip is part of a route and cannot be marked as 'Will Call'. Please remove it from the route first, then mark it as 'Will Call'.");
                        setModalBtnHTML(modalBtn);
                        setShowDynamicModal(true);
                    }
                    else
                    {
                        setModalHeaderText("Trip Status Alert");
                        setModalBodyHTML("Are you sure you want to mark trip#"+rowData.iRefID+" as 'Will Call'?");
                        setModalBtnHTML(
                            <>
                                <Button variant="dark" className="mx-1 border-0" onClick={(e)=>{setShowDynamicModal(false);handleMarkAsWillCall(rowData, modalBtn);}}>
                                    {"Yes"}
                                </Button>
                                <Button variant="secondary" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                                    {"No"}
                                </Button>
                            </>
                        );
                        setShowDynamicModal(true);
                        
                    }
                }
            }
        },
        {
            label:CONTEXT_MENU_LABELS.ASSIGN,
            action:function(e, row){
                sethandlePageProgressBar("dispatch");
                setShowTripActionsDialog(true);
                setGridRefreshPaused(true);
                // row.select();
            }
        },
        {
            label:CONTEXT_MENU_LABELS.UNASSIGN,
            action:function(e, row){
                sethandlePageProgressBar("dispatch")
                //Need to open assign and unassign automatically
                // console.log(row);
                setShowTripActionsDialog(true);
                setTriggerUnAssign(true);
                setGridRefreshPaused(true);
            }
        },
        {
            label:CONTEXT_MENU_LABELS.UNROUTE,
            action:function(e, row){
                sethandlePageProgressBar("dispatch")

                //Need to open manifest/cluster and unroute automatically
                let clusterComparisonTypeID = ['10','11','12','13','14','15','16','17','18','22','23','24'];
                let routeType = row.getData().Route;
                let CDFTypeID = row.getData().CDFTypeID;
                
                // console.log(routeType);
                if(clusterComparisonTypeID.includes(CDFTypeID))
                {
                    setShowClusterDialog(true);
                    setTriggerUnRoute(true);
                }
                else
                {
                    setManifestBuildDialog(true);
                    setTriggerUnRoute(true);
                }
            }
        },
        {
            label:CONTEXT_MENU_LABELS.TRIP_ACTIONS,
            action:function(e, row){
                sethandlePageProgressBar("dispatch");
                let selectedRow = mainTableObj.current.getSelectedRows();
                if(selectedRow.length > 1 && false)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                { 
                    setShowTripActionsDialog(true);
                    setGridRefreshPaused(true);
                }
                // row.select();
            }
        },
        {
            separator:true,
        },
        {
            label:CONTEXT_MENU_LABELS.SEGMENTFARE,
            action:function(e, row){
                let selectedRow = mainTableObj.current.getSelectedRows();
                if(selectedRow.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                {
                    //Any action for this option
                }
                // row.select();
            }
        },
        
        {
            label:CONTEXT_MENU_LABELS.TRIP_HISTORY,
            action:function(e, row){
                let selectedRow = mainTableObj.current.getSelectedRows();
                if(selectedRow.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                {
                    setTripHistoryDialog(true);
                }
                // row.select();
            }
        },
        {
            separator:true,
        },
        {
            label:CONTEXT_MENU_LABELS.TRIP_CLUSTER,
            action:function(e, row){
                sethandlePageProgressBar("dispatch")
                setShowClusterDialog(true);
                // row.select();
            }
        },
        {
            label:CONTEXT_MENU_LABELS.TRIP_GROUP,
            action:function(e, row){
                setShowGroupingActionDialog(true);
                // row.select();
            }
        },
        {
            label:CONTEXT_MENU_LABELS.TRIP_BROKER,
            action:function(e, row){
                let selectedRow = mainTableObj.current.getSelectedRows();
                if(selectedRow.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                {
                    const filteredAffiliates = Array.isArray(BrokerServingAffiliatesData)? 
                    BrokerServingAffiliatesData.filter((aff) => String(aff.iBrokerAffiliateID) === String(row.getData().iSRATSPID)): [];

                    const familyAffiliates = filterAffiliates(AffiliateData, row);
                    
                    if (filteredAffiliates?.length > 0) {
                        setBrokerActionsDialog(true); 
                        setGridRefreshPaused(true);
                    }
                    else{
                        if(familyAffiliates?.length > 1){
                            setBrokerActionsDialog(true); 
                            setGridRefreshPaused(true);

                        }
                        else{
                            setAlertObj({ ...routeObj, alertTitle: 'Broker Action', alertMsg: 'Selected affiliate is not registered as a broker. Please contact your administrator.' , displayFooter: true});
                            setAlert(true);
                            return;

                        }
                       
                    }
                }
                // row.select();
            }
        },
        {
            label:CONTEXT_MENU_LABELS.AGILE_DISPATCH,
            action:function(e, row){
                // let rowInfo = row.getData();
                // if(rowInfo.ServiceStatus?.toUpperCase() === "DISPATCHED" || rowInfo.ServiceStatus?.toUpperCase() === "ASSIGNED" || rowInfo.ServiceStatus.toUpperCase() === "IRTPU" || rowInfo.ServiceStatus.toUpperCase() === "DROPPED" || rowInfo.ServiceStatus.toUpperCase() === "PICKEDUP" || rowInfo.ServiceStatus.toUpperCase() === "ATLOCATION")
                // {
                //     let manageRouteFooterBtns = ["OK"];
                //     let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                //         return(
                //             <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={()=>setShowDynamicModal(false)}>
                //                 {item}
                //             </Button>
                //         );
                //     });
                //     setModalHeaderText("Agile Dispatch Action Alert");
                //     setModalBodyHTML("Trip is not qualifying for the Agile Dispatch, it is already Dispatched.");
                //     setModalBtnHTML(manageRouteFooterHTML);
                //     setShowDynamicModal(true);
                // }
                // else
                // {
                let selectedRow = mainTableObj.current.getSelectedRows();
                if(selectedRow.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                {
                    setShowAgileDispatch(true);
                }
                // }
                // row.select();
            }
        },
        
        {
            label:CONTEXT_MENU_LABELS.TRIP_MANIFEST,
            action:function(e, row){
                sethandlePageProgressBar("dispatch")
                setManifestBuildDialog(true);
            }
        },
        {
            label:CONTEXT_MENU_LABELS.ADD_ROUTE,
            action:function(e, row){
                
                try{
                    sethandlePageProgressBar("dispatch")
                    if(mapViewCheck.current)
                    {
                        
                        if(ClusterTableObject.current !== null && ClusterTableObject.current.getData()[0].Route !== "")
                        {
                            function areAllRoutesEmpty(arr){
                                return arr.every(dict=>dict.Route==='');
                            }
                            let selectedRow = mainTableObj.current.getSelectedRows();
                            let tempRows = [];
                            for(let k in selectedRow)
                            {
                                tempRows.push(selectedRow[k].getData());
                            }

                            const allUnroutedTripsFlag = areAllRoutesEmpty(tempRows);
                            let clusterData = ClusterTableObject.current.getData()[0].ManifestNumber;
                            let ClusterTypeID = ClusterTableObject.current.getData()[0].ClusterTypeID;
                            let clusterComparisonTypeID = ['10','11','12','13','14','15','16','17','18','22','23','24'];
                            if(allUnroutedTripsFlag)
                            {
                                // console.log(clusterData);
                                if (clusterComparisonTypeID.includes(ClusterTypeID))
                                {
                                    setRoute(clusterData);
                                    setAddTripToRouteCluster(true);
                                    setShowClusterDialog(true);
                                }
                                else
                                {
                                    setRoute(clusterData);
                                    setAddTripToRoute(true);
                                    setManifestBuildDialog(true);
                                }
                                
                            }
                            else
                            {
                                let manageRouteFooterBtns = ["OK"];
                                let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                                    return(
                                        <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={()=>setShowDynamicModal(false)}>
                                            {item}
                                        </Button>
                                    );
                                });
                                setModalHeaderText("Add to Route Alert");
                                setModalBodyHTML("Please click on an un-routed trip.");
                                setModalBtnHTML(manageRouteFooterHTML);
                                setShowDynamicModal(true);
                            }

                        }
                        else
                        {
                            setRoute(SelectedRoute);
                            setAddTripToRoute(true);
                            setManifestBuildDialog(true);

                        }
                    }
                    else
                    {

                        setRoute(SelectedRoute);
                        setAddTripToRoute(true);
                        setManifestBuildDialog(true);
     
                    }
                }
                catch(err){console.log(err);}
            }
        },
        {
            label:CONTEXT_MENU_LABELS.TRIP_DETAILS,
            action:function(e, row){
                let selectedRows = mainTableObj.current.getSelectedRows();
                if(selectedRows.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"Please select a single trip to edit."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else if(selectedRows.length === 1)
                {
                    PersistStorage.save("IsTripDetailsDialogOpened", true, 10, false);
                    setTripDetailsDialog(true);
                }
            }
        },
        {
            label:CONTEXT_MENU_LABELS.Rider_Notes,
            action:function(e, row){
                let selectedRow = mainTableObj.current.getSelectedRows();
                if(selectedRow.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                {
                    setAgentNotesDialog(true);
                }
                // row.select();
            }
        },
        {
            label:CONTEXT_MENU_LABELS.ROUTE_SUGGESTIONS,
            action:function(e, row){
                let selectedRow = mainTableObj.current.getSelectedRows();
                if(selectedRow.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                {
                    sethandlePageProgressBar("dispatch")
                    let slectedrowsdata= DispatchTableObject.current
                    let routename = row.getData().Route;
                    
                    if(slectedrowsdata.length > 1){
                        setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Route Suggestion', body:'Please select single unrouted trip.', btnCancelText: 'No', btnOkText: 'Ok'}));

                    }
                    else{
                        if (routename === '' || routename === null){
                            PersistStorage.save("selectedDate", RefSelectedDate.current, 999, false);
                            PersistStorage.save("AffiliateID", row.getData().PrimaryAffiliateID, 999, false);
                            setRouteSuggestionActionCreate(true);
                        }
        
                        else{
                            setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Route Suggestion', body:'Please select single unrouted trip.', btnCancelText: 'No', btnOkText: 'Ok'}));
                        }
                    }
                }
            }
        },
    ];

    const filterAffiliates = (AffiliateData, row) => {
        const rowData = row.getData();
        const { iSRATSPID } = rowData;
      
        // Validate input data
        if (!iSRATSPID) {
          console.error("Invalid row data: iSRATSPID is missing.");
          return [];
        }
      
        // Find the `iPartnerAffiliateID` for the given `iSRATSPID`
        const matchingAffiliate = AffiliateData.find(
          (affiliate) => affiliate.AffiliateID === parseInt(iSRATSPID)
        );
      
        if (!matchingAffiliate) {
          console.warn(`No affiliate found with AffiliateID: ${iSRATSPID}`);
          return [];
        }
      
        const { iPartnerAffiliateID } = matchingAffiliate;
      
        // Filter affiliates with the same `iPartnerAffiliateID`
        return AffiliateData.filter(
          (affiliate) => affiliate.iPartnerAffiliateID === parseInt(iPartnerAffiliateID)
        );
      };
    

    ContextMenuArray = ContextMenuArray.filter(item=>{
        if(!ModuleSecurity.CheckModuleSecurityByTag("tag_CancelRequest") && item.label === CONTEXT_MENU_LABELS.CANCEL){
            return false;
        }
        if(!ModuleSecurity.CheckModuleSecurityByTag("tag_DispatchActions") && item.label === CONTEXT_MENU_LABELS.AGILE_DISPATCH){
            return false;
        }
        return true;
    });
    
    const [DispatchGridControlOptions, SetDispatchGridControlOptions] = useState({
            height: 'auto',
            heightoffset: 145,
            calculateHeight: true,
            pagination: true,
            paginationMode: "local",
            paginationSize: 1000,
            paginationSizeSelector: [100, 300, 500, 1000, 5000],
            selectable: true,
            reactiveData:true, //enable data reactivity
            layout: "fitDataStretch",
            placeholder:"No Trips Available",
            clipboard: true,
            mapHeight: "auto",
            selectableRangeMode: "click",
            GridName:"tabulator",
            paginationCounter:"rows",
            intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
            EnableProgressBar: true,
            index: "ConfirmationNo",
            movableColumns:true,
            movableRows: false,
            vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
            bSysUser: 1,
            intervalEnable: true,
            persistence:true,
            bWebApplySettingToAll: false,
            mapClass: "col-6 d-inline-flex",
            ID_Column: "ConfSchDtl",
            GridReturnOnlyIDColumnInRowData: false,
            AlwaysHiddenColumns:["AffPhoneNo","AssignedDriverId","CallbackInfo","CallbackMethod","CallOutStatus","CallRecieve","CancelComment","CheckInState","DateCallback","DateCreation","DispatchedBy","DispatchMethod","DODev","DriverCellPhone","DriverHomePhone","DriverNearDropLoc","DriverPhone","DropCity","DropLatitude","DropLongitude","DropState","DropZip","EstCostSort","ExtraInformation","iAssignedVehicleId","iClassOfServiceID","iCreatedByAppID","iFundingSourceID","iMVOriginalATSPID","iMVRouteATSPID","iRefID","iScheduleID","iSpecialDriverId","iSpecialVehicleId","iVehicleTypeId","LastModifiedBy","MilesPickOrDrop","PaymentExtention1","PaymentExtention3","PickupCity","PickupLatitude","PickupLongitude","PickupSort","PickupState","PickupZip","PromoAmount","PromotionCode","ProviderCost","ProviderMileage","PUDev","ShowDAffiliateTripsToATSP","StandingRoute","TotalCancelled","TotalNoShows","TripAttributes","vCompanyPBXAPIURL"/*,"vManifestNumber"*/,"vMarsID","vPBXCompany","VREQ","CDFTypeID", "PUSortTime"],
            saveCCSettingsOption: true,
            mapView: mapView,
            contextMenuSetting: ContextMenuArray,
            selectedRoute:SelectedRoute,
            containerClass: "col",
            Containerstyle: {},
            frozenState: true,
            sortCondition: true,
            groupByColumns: [],//["No Column Grouping", "Group", "Attribute", "TripRequestStatus", "FundingSource", "Route"],
            GridGroupedColumns: ["No Column Grouping", "Group", "Attribute", "TripRequestStatus", "FundingSource", "Route", "PZONE", "DZONE","PickupCity", "DropCity"],
            tableDoubleClickFunc: function(table, row) {
                table.deselectRow();
                
                row.select();
                
                
                ClusterGridSelectedRows.current = [];
                ClusterGridSrollVertical.current = 0;
                ClusterGridDataResetComplete.current = false;
                setTableRowsSel(row.getData().id);
                if(!document.getElementById("tabulator_mapContainer"))
                {
                    document.getElementById("tabulator_mapViewBtn").click();               
                }
                if(typeof GridRowDoubleClick !== "undefined"){
                    DropDownRouteValue.current = null
                    
                    let selectedrowRoute = row.getData().Route;
                    setMapViewFromDoubleClick(true)
                    
                    if(selectedrowRoute !== "")
                    {
                        
                        // someThingChangedInGrid.current = true;
                        selectedTripInfo.current = row.getData();
                        selectedTripInfoToRefreshGrid.current = row.getData();
                        handleClusterManifestData(row.getData(), checkboxSelectionFlag.current);
                    }
                    else if(selectedrowRoute === "")
                    {
                        // someThingChangedInGrid.current = true;
                        selectedTripInfo.current = row.getData();
                        selectedTripInfoToRefreshGrid.current = row.getData();
                        GridRowDoubleClick(row.getData());
                    }
                    
                    setTimeout(() => {
                        setSelectedRoute(row.getData().vManifestNumber);
                    }, 1000);
                    
                }
            },
            footerElement : '<button class="tabulator_btns raised-button border border-dark " title="Export To Excel" id="'
                +"tabulator"+'_ExportToExcel"></button><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
                +"tabulator"+'_ClearFilter" title="Clear Filters" id="'+"tabulator"+'_ClearFilter"></button><button class="tabulator_btns lastTabulator-btn raised-button border border-dark " title="Reload Data" id="'
                +"tabulator"+'_RefreshData"></button><button class="tabulator_btns raised-button border border-dark " title="Select All Rows" id="'
                +"tabulator"+'_SelectAll"></button><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
                +"tabulator"+'_DeSelectAll" title="Deselect Selected" id="'+"tabulator"+'_DeSelectAll"></button> '
                +'<div class="tabulator_group_'+"tabulator"+'"><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
                +"tabulator"+'_ExpandCollapse" title="Collapse Grouped Trips" id="'+"tabulator"+'_ExpandCollapse"></button>'
                +'<select class="tabulator_btns gridgroupedcols DropdownArrow raised-button border border-dark " id="gridgroupedcolstabulator" style="cursor:pointer; width:auto; margin-left:-2px;">'
                +'</select><button class="tabulator_btns middleTabulator-btns raised-button border border-dark" style="display:none;" '
                +"tabulatorSaveSettings"+'" title="Collapse Grouped Trips" id="tabulatorSaveSettings">Save Grid Settings</button></div><span class="middleTabulator-btns fw-normal'
                +"tabulator"+'_recordSelected" id="'+"tabulator"+'_selectedRecords" style="font-size:small"></span><div class="progress lastTabulator-btn user-select-none" style="width:100px"><div animated class="progress-bar '
                +'progress-bar-animated progress-bar-striped tabulatorProgressBar" aria-valuemin="0" aria-valuemax="100"></div></div>',
            footerElementHandles: function (table) {
                mainTableObj.current = table;
                //<button class="tabulator_btns" title="Select Column To Group By" id="'+"tabulator"+'_ColSelectGrouping"></button>
                var img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px"; 
                    img.src = saveIcon;
                    document.getElementById("tabulator_ExportToExcel").appendChild(img);
                img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px"; 
                    img.src = clearFilterIcon;
                    document.getElementById("tabulator_ClearFilter").appendChild(img);
                img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px"; 
                    img.src = selectAllIcon;
                    document.getElementById("tabulator_SelectAll").appendChild(img);
                img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px"; 
                    img.src = deSelectIcon;
                    document.getElementById("tabulator_DeSelectAll").appendChild(img);
                img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px"; 
                    img.src = refreshIcon;
                    document.getElementById("tabulator_RefreshData").appendChild(img);
                img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px";
                    img.id = "expandCollapseImg"; 
                    img.src = collapseIcon;
                    document.getElementById("tabulator_ExpandCollapse").appendChild(img);
                    
                if(document.getElementById('tabulator_selectedRecords').innerHTML === "")
                {
                    document.getElementById('tabulator_selectedRecords').innerHTML = "[No Trips Selected]";
                }
                //select row on "select all" button click
                document.getElementById('tabulator_SelectAll').addEventListener("click", function(){
                    table.selectRow();
                });
                //deselect row on "deselect all" button click
                document.getElementById('tabulator_DeSelectAll').addEventListener("click", function(){
                    table.deselectRow();
                });
                document.getElementById("tabulator_ExportToExcel").addEventListener("click", function(){
                    const data = table.getData('active');
                    const columnsToIgnore = ['id'];
                    var filteredData = data.map(row =>{
                        const filteredRow = {...row};
                        columnsToIgnore.forEach(column => delete filteredRow[column]);
                        return filteredRow;
                    });
                    
                    const sheet = XLSX.utils.json_to_sheet(filteredData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                    XLSX.writeFile(wb, "table_data.xlsx");
                    
                });
                document.getElementById('tabulator_ClearFilter').addEventListener("click", function(){
                    table.clearHeaderFilter();
                });
                document.getElementById('tabulator_ExpandCollapse').addEventListener("click", function(){
                    try{
                        let element = document.getElementById("tabulator_ExpandCollapse");
                        let oldImage = document.getElementById("expandCollapseImg");
                        if(groupingFilterCheck.current.toLowerCase() !== "no column grouping")
                        {
                            if(element.title.toLowerCase().includes("collapse"))
                            {
                                element.removeChild(oldImage); 
                                var img = document.createElement("img");
                                    img.style.cssText = "width:16px; height:16px";
                                    img.id = "expandCollapseImg"; 
                                    img.src = expandIcon;
                                element.appendChild(img);
                                element.title = "Expand Grouped Trips";
                                //document.getElementById("tabulator_RefreshData").click();
                                table.setGroupBy(false);
                                table.setGroupStartOpen(false);
                                table.setGroupBy(groupingFilterCheck.current);
                            }
                            else
                            {
                                element.removeChild(oldImage);
                                var img = document.createElement("img");
                                    img.style.cssText = "width:16px; height:16px";
                                    img.id = "expandCollapseImg"; 
                                    img.src = collapseIcon;
                                element.appendChild(img);
                                element.title = "Collapse Grouped Trips";
                                //document.getElementById("tabulator_RefreshData").click();
                                table.setGroupBy(false);
                                table.setGroupStartOpen(true);
                                table.setGroupBy(groupingFilterCheck.current);
                            }
                        }
                    }
                    catch(err){console.log(err);}
                });
                //Opening column chooser
                // document.getElementById('tabulator_ColumnChooser').addEventListener("click", function(){
                //     setShowColumnChooser(true);
                // });
            },
            rowSelectionChangeHandle: function(data){
                DispatchTableObject.current = data;
                function areAllRoutesEmpty(arr){
                    return arr.every(dict=>dict.Route==='')
                }
                if(data.length === 0)
                {
                    document.getElementById('tabulator_selectedRecords').innerHTML = "[No Trips Selected]";
                    if(routedTripShow.current.route !== "")
                    {
                        routedTripShow.current = {"route":routedTripShow.current.route, "data":""};                      
                    }
                    
                    routedTripShow.current = {"route":routedTripShow.current.route, "data":""};
                    unroutedTripShow.current = {"unroutedTripConf": unroutedTripShow.current.unroutedTripConf, "data":data};
                }
                else if(data.length === 1)
                {
                    document.getElementById('tabulator_selectedRecords').innerHTML = "["+data.length+" Trip Selected]";
                }
                else
                {
                    document.getElementById('tabulator_selectedRecords').innerHTML = "["+data.length+" Trips Selected]";
                }

                if(unroutedTripShow.current.unroutedTripConf !== "")
                {
                    if(data.length > 0)
                    {
                        let sameTripFinder = data.find((item)=> item.ConfirmationNo === unroutedTripShow.current.unroutedTripConf);
                        if(sameTripFinder !== undefined)
                        {
                            unroutedTripShow.current = {"unroutedTripConf": unroutedTripShow.current.unroutedTripConf, "data":data};
                        }
                        else
                        {
                            const result = areAllRoutesEmpty(data);
                            if(result)
                            {
                                unroutedTripShow.current = {"unroutedTripConf": unroutedTripShow.current.unroutedTripConf, "data":data};
                            }
                            else{
                                const filteredArray = data.filter(obj => obj.Route == "");
                                unroutedTripShow.current = {"unroutedTripConf": "", "data":filteredArray};
                            }
                        }
                    }
                    else if(data.length === 0)
                    {
                        unroutedTripShow.current = {"unroutedTripConf": unroutedTripShow.current.unroutedTripConf, "data":""};
                    }
                    
                }
                else if(unroutedTripShow.current.unroutedTripConf === "" && data.length > 0)
                {
                    const result = areAllRoutesEmpty(data);
                    if(result)
                    {
                        unroutedTripShow.current = {"unroutedTripConf": "", "data":data};
                    }
                    else{
                        const filteredArray = data.filter(obj => obj.Route == "");
                        unroutedTripShow.current = {"unroutedTripConf": "", "data":filteredArray};
                    }
                }

                if(routedTripShow.current.route !== "" && data.length > 0)
                {
                    if(data.length === 1 && data[0].Route === "")
                    {
                        routedTripShow.current = {"route":routedTripShow.current.route, "data":data};
                    }
                    else if(data.length > 1)
                    {
                       
                        const result = areAllRoutesEmpty(data);
                        if(result)
                        {
                            routedTripShow.current = {"route":routedTripShow.current.route, "data":data};
                        }
                        else{
                            const filteredArray = data.filter(obj => obj.Route != "");
                            routedTripShow.current = {"route":"", "data":filteredArray};
                        }
                    }
                }
                else if(routedTripShow.current.route !== "" && data.length === 0)
                {
                    routedTripShow.current = {"route":routedTripShow.current.route, "data":""};
                }
            },

            GridScrollVertical: function(top, table = ""){
                setGridRefreshPaused(false);
                let multiSelectContainer = document.getElementsByClassName('multi-select')
                if (multiSelectContainer.length > 0) {
                    multiSelectContainer[0].style.display = 'none';

                    try {
                        if (typeof table.previousValue !== 'undefined') {
                            if (table.previousValue !== null) {
                                if (table.previousCellData) {
                                    table.previousCellData.row.data[table.previousCellData.column.field] = table.previousValue;
                                    table.updateData([table.previousCellData.row.data]);
                                }
                            }
                        }
                    } catch (e) {
                    }
                }

            },
            
            cellClickHandle: function (e, cell_data, table, cellPositionDetails) {

                let data_len = table.getSelectedData().length;
                try {
                    if (typeof table.previousValue !== 'undefined') {
                        if (table.previousValue !== null) {
                            if (table.previousCellData &&
                                (table.previousCellData.row !== cell_data._cell.row || table.previousCellData.column !== cell_data._cell.column)) {
                                table.previousCellData.row.data[table.previousCellData.column.field] = table.previousValue;
                                if (table.previousCellData.row.data == cell_data._cell.row.data.iSRATSPID) {
                                    table.updateData([table.previousCellData.row.data]);
                                }
                                let rowElement = table.previousCellData.row.getElement();

                                if (rowElement) {
                                    rowElement.style.zIndex = '';
                                }
                            }
                        }
                    }

                } catch (e) {}

                if (cell_data._cell.column.field === "Attribute" && data_len === 1) {

                    let attrSelection = AttributeData.filter((item) =>
                        parseInt(item.iAttrATSPID) === parseInt(cell_data._cell.row.data.iSRATSPID)
                    );

                    let attrOptionsSel = attrSelection.map((item) => ({
                        id: item.ID,
                        name: item.Title,
                        shortName: item.ShortTitle
                    })).sort((a, b) => a.name.localeCompare(b.name));

                    try {
                        let isMultiSelectInAttribute = cell_data._cell.row.data.Attribute.includes('input')
                        let previousAttributeValue = ''
                        if (!isMultiSelectInAttribute) {
                            previousAttributeValue = cell_data._cell.row.data.Attribute;
                        }
                    } catch (e) {}
                    // Save the current cell data and value for future restoration

                    table.previousCellData = {
                        row: cell_data._cell.row,
                        column: cell_data._cell.column
                    };
                    table.previousValue = cell_data._cell.row.data[cell_data._cell.column.field];

                    const selectedValues = [];

                    const parentContainer = document.createElement('div');

                    parentContainer.style.height = '19px';
                    parentContainer.style.width = 'inherit';
                    parentContainer.style.top = (cellPositionDetails.y - 106) + 'px';
                    parentContainer.style.left = cellPositionDetails.x + 'px';
                    // parentContainer.style.border = '1px solid #ccc';
                    parentContainer.style.padding = '10px';
                    parentContainer.style.cursor = 'pointer';
                    parentContainer.style.position = 'fixed';
                    parentContainer.style.display = 'flex';
                    parentContainer.style.alignItems = 'center';
                    parentContainer.style.justifyContent = 'space-between';

                    // parentContainer.style.backgroundColor = '#fff';

                    const displayText = document.createElement('span');
                    displayText.textContent = 'Select Attribute';
                    displayText.style.flexGrow = '1';
                    displayText.style.whiteSpace = 'nowrap';
                    displayText.style.overflow = 'hidden';
                    displayText.style.textOverflow = 'ellipsis';

                    const dropdownIcon = document.createElement('span');
                    dropdownIcon.textContent = '▼';
                    dropdownIcon.style.marginLeft = '10px';
                    parentContainer.appendChild(displayText);
                    parentContainer.appendChild(dropdownIcon);
                    const multiSelectContainer = document.createElement('div');
                    multiSelectContainer.classList.add('multi-select');
                    multiSelectContainer.style.position = 'fixed';
                    multiSelectContainer.style.top = 'auto';
                    multiSelectContainer.style.left = '0';
                    multiSelectContainer.style.width = 'inherit';
                    multiSelectContainer.style.border = '1px solid #ccc';
                    multiSelectContainer.style.backgroundColor = '#fff';
                    multiSelectContainer.style.maxHeight = '200px';
                    multiSelectContainer.style.overflowY = 'auto';
                    multiSelectContainer.style.display = 'none';
                    multiSelectContainer.style.zIndex = '111111 !important';
                    multiSelectContainer.style.height = '20%';

                    attrOptionsSel.forEach(attr => {

                        const optionDiv = document.createElement('div');
                        optionDiv.classList.add('custom-option');
                        optionDiv.style.padding = '5px';
                        optionDiv.style.display = 'flex';
                        optionDiv.style.alignItems = 'center';
                        optionDiv.style.position = 'unset';
                        optionDiv.style.zIndex = '99999';

                        const checkbox = document.createElement('input');
                        checkbox.type = 'checkbox';
                        checkbox.id = attr.id;
                        checkbox.value = attr.id;
                        checkbox.setAttribute('optionTitle', attr.name)
                        checkbox.setAttribute('optionShortTitle', attr.shortName)

                        try {
                            if (cell_data._cell.row.data.Attribute.includes(attr.id.toString())) {
                                checkbox.checked = true;
                                selectedValues.push({id: attr.id, name: attr.name, shortName: attr.shortName});
                            }

                        } catch (e) {}
                        checkbox.classList.add('custom-checkbox');

                        const label = document.createElement('label');
                        label.htmlFor = attr.id;
                        label.textContent = attr.name;
                        label.style.marginLeft = '5px';
                        label.classList.add('custom-option-input-label');
                        optionDiv.appendChild(checkbox);
                        optionDiv.appendChild(label);
                        multiSelectContainer.appendChild(optionDiv);
                    });

                    parentContainer.appendChild(multiSelectContainer);
                    cell_data._cell.row.data.Attribute = parentContainer;
                    let rowElement = cell_data._cell.row.getElement();
                    rowElement.style.zIndex = '9999999';
                    // Toggle visibility of options on click

                    parentContainer.addEventListener('click', (e) => {

                        e.stopPropagation();

                        if (!(e.target.classList.contains('custom-checkbox') || e.target.classList.contains('custom-option') || e.target.classList.contains('custom-option-input-label'))) {

                            if (multiSelectContainer.style.display === 'none') {
                                setGridRefreshPaused(true);
                                const parentTop = parentContainer.offsetTop;
                                const parentHeight = parentContainer.offsetHeight;
                                multiSelectContainer.style.top = `${parentTop + parentHeight}px`;
                                multiSelectContainer.style.top = `${parentTop + parentHeight}px`;
                                if (parseInt(multiSelectContainer.style.top.replace(/px/g, "")) > (window.innerHeight - 500)) {
                                    multiSelectContainer.style.top = (parseInt(multiSelectContainer.style.top.replace(/px/g, "")) - (window.innerHeight * 0.2)).toString() + "px";
                                }
                                multiSelectContainer.style.left = `${parentContainer.offsetLeft}px`;
                                multiSelectContainer.style.display = 'block';
                                const rowElement = multiSelectContainer.closest('.tabulator-row');
                                if (rowElement) {
                                    rowElement.style.zIndex = '99999';
                                }
                            } else {
                                multiSelectContainer.style.display = 'none';
                                setGridRefreshPaused(false);
                            }
                        }
                    });

                    document.addEventListener('click', function handleClickOutside(event) {
                        if (!parentContainer.contains(event.target)) {
                            multiSelectContainer.style.display = 'none';
                            setGridRefreshPaused(false);
                        }
                    });
                    setTimeout(() => {
                        const checkboxes = document.querySelectorAll('.custom-checkbox');
                        checkboxes.forEach(checkbox => {
                            if (!checkbox.dataset.listenerAdded) {
                                checkbox.addEventListener('change', async (e) => {
                                    let value = checkbox.value;
                                    let selectedName = checkbox.getAttribute('optionTitle');
                                    let selectedShortName = checkbox.getAttribute('optionShortTitle');
                                    if (checkbox.checked) {
                                        if (!selectedValues.some(item => item.id == value)) {
                                            selectedValues.push({id: value, name: selectedName, shortName: selectedShortName});
                                        }
                                    } else {
                                        const index = selectedValues.findIndex(item => item.id == value);
                                        if (index !== -1) {
                                            selectedValues.splice(index, 1);
                                        }
                                    }
                                        let payload = {
                                            "iRefID": cell_data._cell.row.data.ConfirmationNo,
                                            "iATSPID": cell_data._cell.row.data.iSRATSPID,
                                            "vAttributeIDsList": selectedValues.map(item => item.id).join(","),
                                        };
                                        await APICom.fetchData("", "TripActions/UpdateTripAttributes", "post", {"Content-Type": "application/json"}, payload, null);
                                    let htmlString = "";

                                    for (const selectedValue of selectedValues) {
                                        htmlString += `<p systemattribute="0" title="${selectedValue.name}" attr${selectedValue.id}>${selectedValue.shortName}</p>`;
                                    }

                                    try {
                                        let tempDiv = document.createElement('div')
                                        tempDiv.innerHTML = table.previousValue;

                                        let attributeToRemove = tempDiv.querySelectorAll('p[systemattribute="0"]');
                                        attributeToRemove.forEach(element => element.remove());
                                        let updatedPreviousValueHTML = tempDiv.innerHTML;

                                        table.previousValue = updatedPreviousValueHTML + htmlString
                                    } catch (e) {
                                    }

                                });
                                checkbox.dataset.listenerAdded = true;
                            }
                        });

                    }, 0);
                }
            },

        });
    const [ClusterGridControlOptions, SetClusterGridControlOptions] = useState({
        height: 'auto',
        heightoffset: 200,
        calculateHeight: false,
        pagination: true,
        paginationMode: "local",
        paginationSize: [100, 200, 300],
        selectable: true,
        reactiveData:true, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"clusterTableGrid",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        movableRows: true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_NewC",
        index: "Index",
        autoColumns: true,
        intervalEnable: false,
        bWebApplySettingToAll: true,
        bSysUser: 1,
        saveCCSettingsOption: true,
        GridReturnOnlyIDColumnInRowData: false,
        persistence: false,
        CCAddition: true,
        contextMenuSetting: ContextMenuStopView,
        sortCondition: false,
        ID_Column: "Index", 
        // AlwaysHiddenColumns:["AffPhoneNo","AssignedDriverId","CallbackInfo","CallbackMethod","CallOutStatus","CallRecieve","CancelComment","CheckInState","DateCallback","DateCreation","DispatchedBy","DispatchMethod","DODev","DriverCellPhone","DriverHomePhone","DriverNearDropLoc","DriverPhone","DropCity","DropLatitude","DropLongitude","DropState","DropZip","EstCostSort","ExtraInformation","iAssignedVehicleId","iClassOfServiceID","iCreatedByAppID","iFundingSourceID","iMVOriginalATSPID","iMVRouteATSPID","iRefID","iScheduleID","iSpecialDriverId","iSpecialVehicleId","iVehicleTypeId","LastModifiedBy","MilesPickOrDrop","PaymentExtention1","PaymentExtention3","PickupCity","PickupLatitude","PickupLongitude","PickupSort","PickupState","PickupZip","PromoAmount","PromotionCode","ProviderCost","ProviderMileage","PUDev","ShowDAffiliateTripsToATSP","StandingRoute","TotalCancelled","TotalNoShows","TripAttributes","vCompanyPBXAPIURL","vManifestNumber","vMarsID","vPBXCompany","VREQ"],
        containerClass: "",
        Containerstyle: {top:"-6px"},
        footerElement: '<input type="checkbox" id="clusterTableGrid_checkbox" class="tabulator_checkbox" title="Auto Refresh" style="margin-right: 10px;">'
                +'<button class="tabulator_btns" title="Export to Excel" id="'
                +"clusterTableGrid"+'_ExportToExcel"></button><button class="tabulator_btns middleTabulator-btns" title="Adjust Time & Validate Route" id="'
                +"clusterTableGrid"+'_AdjustTimes"></button><button class="tabulator_btns middleTabulator-btns" '
                +' title="Commit Changes" id="'+"clusterTableGrid"+'_Commit"></button>'
                +'<button class="tabulator_btns middleTabulator-btns" '
                +' title="Validate Route" id="'+"clusterTableGrid"+'_validate"></button>'
                +'<button class="tabulator_btns lastTabulator-btn" '
                +' title="Display Violations Legend" id="'+"clusterTableGrid"+'_infoViolations"></button>',

        tableDoubleClickFunc: function(table, row) {
        },
        AlwaysHiddenColumns: ["iID_RouteGeneralSettings", "iServiceID", "iScheduleID", "StylCondDev" , "ManifestNumber", "ReqTimeHidden", 
                                "bIsScheduled", "dLateTimeWindow", "dFinalEndTimeWindow", "dFinalEndTimeWindow", "dFinalApptTimeWindow",
                                "CustomerSignature", "iCreatedByAppID", "iSRATSPID", "vColor", "dtReqIRTPU", "dtDriverLoc", "iRouteID",
                                "BusLine", "dEarlyTimeWindow", "vManifestDisposition", "iVehStopOrder", "ServiceRequestType", "SortOrder", "Eta", "iTotalWheelChairs",
                                "iTotalPassengerCount", "bWillCall","bPerformed", "iVehicleID", "iAffiliateID", "CDPUStopNo", "CDDOStopNo", "dtDriverDropLoc", "dUpdateSchWinMins"
                            ],
        GeneralArrayForHTML : ["Violation"],
        footerElementHandles: function (table, TableData) {

            ClusterTableObject.current = table;
            // ClusterTableObject.current.selectRow( ClusterTableObject.current.getData()[0].Index);
            var img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px"; 
                    img.src = saveIcon;
                    document.getElementById("clusterTableGrid_ExportToExcel").appendChild(img);
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = AdjustTimes;
                document.getElementById("clusterTableGrid_AdjustTimes").appendChild(img);
            img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px";
                img.src = CommitTimes;
                document.getElementById("clusterTableGrid_Commit").appendChild(img);

            img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ValidateIcon;
                document.getElementById("clusterTableGrid_validate").appendChild(img);

            img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = infoIcon;
                document.getElementById("clusterTableGrid_infoViolations").appendChild(img);
            
            document.getElementById("clusterTableGrid_ExportToExcel").addEventListener("click", function(){
                    const data = table.getData('active');
                    const columnsToIgnore = ['id'];
                    var filteredData = data.map(row =>{
                        const filteredRow = {...row};
                        columnsToIgnore.forEach(column => delete filteredRow[column]);
                        return filteredRow;
                    });
                    
                    const sheet = XLSX.utils.json_to_sheet(filteredData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                    XLSX.writeFile(wb, "cluster_table_data.xlsx");
                    
            });
            
            document.getElementById('clusterTableGrid_Commit').addEventListener("click", async function(){ 
                CommitActions();
            });
            
            document.getElementById('clusterTableGrid_validate').addEventListener("click", async function(){
                ValidateRoute();
            });

            // Update checkbox state based on condition
            const autoRefreshCheckbox = document.getElementById('clusterTableGrid_checkbox');
            if (autoRefreshCheckbox) {
                if(someThingChangedInGrid.current === true){
                    autoRefreshCheckbox.checked = false;
                }
                else{
                    autoRefreshCheckbox.checked = true;

                }
            }

            document.getElementById('clusterTableGrid_checkbox').addEventListener("click", async function(){
                AutoRefresh();
            });
            document.getElementById('clusterTableGrid_AdjustTimes').addEventListener("click", async function(){
                AdjustRouteTimes();
            });
            document.getElementById('clusterTableGrid_infoViolations').addEventListener("click", function(){
                let manageRouteFooterBtns = ["Close"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={()=>setShowDynamicModal(false)}>
                            {item}
                        </Button>
                    );
                });
                let manageBodyHTML = function(index){
                    return(
                        <Row key={index} className="border rounded p-1">
                            <Col>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Capacity(CV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Time Window(TWV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Ride Time(RTV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Max Miles(MMV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Driver Break(DBV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Unique Stops(USV):"}</p>
                            </Col>
                            <Col>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].capacity}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].timeWindow}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].RideTime}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].maxMilesHours}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].driverBreak}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].uniqueStops}}></div>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Non Drop(NDV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Pickup Loop Back(PLV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Will Call Trips(WCV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Route Start Time(EST):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Max Trips(MTV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Invalid DO GPS(DGDSV):"}</p>
                            </Col>
                            <Col>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].nonDrop}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].puLoopBack}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].WillCallTrip}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].TripStartTime}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].MaxTrips}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].invalidDOGPS}}></div>
                            </Col>
                            <Row>
                                <Col xs={5}>
                                    <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Max Route Hours(RHV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Invalid PU GPS(PGPSV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Ride Sharing(RSV):"}</p>
                                </Col>
                                <Col xs={7} style={{marginLeft:"-6.0%"}}>
                                    <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].maxRouteHrs}}></div>
                                    <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].invalidPUGPS}}></div>
                                    <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].RideSharing}}></div>
                                </Col>
                            </Row>
                        </Row>
                        
                    );
                };
                setModalHeaderText("Violations Legend");
                setModalBodyHTML(manageBodyHTML);
                setModalBtnHTML(manageRouteFooterHTML);
                setShowDynamicModal(true);
            });
        },
        rowSelectionChangeHandle: function(data){
            try {
                ClusterGridSelectedRows.current = data;
                if (data.length === 1) {
                    setSelectedStopsData(data);
                    // Single row selected
                    const selectedRow = data[(data.length-1)]; // Get the first (and only) selected row
                    setClusterTripSelection({
                        Number: selectedRow.TripNo,
                        Type: selectedRow.Type
                    });
                } else if (data.length > 1) {
                    // Multiple rows selected
                    const sortedData = data.sort((a, b) => a['Stop#'] - b['Stop#']);
                    setSelectedStopsData(sortedData);

                    // const selectedTrips = data.map(row => ({
                    //     Number: row.TripNo,
                    //     Type: row.Type
                    // }));
        
                    // setClusterTripSelection(selectedTrips);
                    // console.log('Multiple rows selected:', selectedTrips);
                } else {
                    // No rows selected (optional handling)
                    setClusterTripSelection(null);
                    console.log('No rows selected');
                }
            } catch (err) {
                console.log('Error handling row selection change:', err);
            }
            // try{
            //     // someThingChangedInGrid.current = false;
            //     setClusterTripSelection({Number:data[(data.length-1)].TripNo, Type: data[(data.length-1)].Type});
            // }
            // catch(err){console.log(err);}
        },
        GridAfterDataFetching: function(table){

        },
        GridDataLoadComplete: function(table){
            if(table!=null){
                if(ClusterGridSelectedRows.current != null && ClusterGridSelectedRows.current.length > 0){
                    let indexValuesArray = ClusterGridSelectedRows.current.map(row => row.Index);
                    table.selectRow(indexValuesArray);
                }
                table.rowManager.element.scrollTop = ClusterGridSrollVertical.current;
                ClusterGridDataResetComplete.current = true;
            };
        },
        GridScrollVertical: function(top, table = ""){
            ClusterGridSrollVertical.current = top;
        },
        GridDataCompareAndUpdate: function(OldData, NewData){
            return ClusterGridDataResetComplete.current; //This is maintained in the parent function so that we only update the data rather then destroy and create.
        },
        // clusterColModel: ["Actions", "StopOrder", "pickLat", "pickLng", "dropLat", "dropLng", "ConfirmationNo", "StopType", "Route", "PUPerson", "ReqTime", "ETA", "StopStatus", "Custom", "TSPID", "vAddress", "VehicleNum", "vManifestNumber", "nTotalWheelChairs"],
        ActionList: true,
        ActionRowColoring: true,
        ArrangeClusterTripsErrorCases: [{"TripAtTop":"Trip is already at the top.", "TripAtBottom":"Trip is already at the bottom.", 
        "PUAfterDO": "Pickup can't come after its Dropoff!", "DOBeforePU":"Dropoff can't come before its Pickup!",
        "PrevRowNotExist":"Action not allowed because no previous row exist", "PrevDepotTrip":"Action not allowed because previous trip is depot trip",
        "PrevWillCallTrip":"Action not allowed because previous trip is a will call trip", "PerformedStops":"Action not allowed because trip has already been performed",
        "PrevPerformedStop":"Action not allowed because previous trip has already been performed",
        "PrevBreakTrip":"Action not allowed because previous trip is a break trip", "NextDepotTrip":"Action not allowed because next trip is depot trip",
        "NextvWillCallTrip":"Action not allowed because next trip is a will call trip","NextBreakTrip":"Action not allowed because next trip is a break trip",
        "NextPerformedStop":"Action not allowed because next trip has already been performed",
        "CompletedTrip":"Action not allowed because dragged trip has already been performed"
        }],
    });
    const [xCancelSource, setxCancelSource] = useState([]);
    const xCancelSourceForGrid = useRef(null);
    const iDispatchRequestCountUnderProgress = useRef(0);
    const toolBoxRef = useRef({});
    const [TimeTakenByLastGridCall, setTimeTakenByLastGridCall] = useState(0);
    const [NetworkTimeTakenByLastGridCall, setNetworkTimeTakenByLastGridCall] = useState(0);

    const [ToolboxValues, SetToolboxValues] = useState({
        Date:"", AffiliatesList:"",FSList:"",AttrList:"", StatusList:"", TotalHours: 24
    });    

    const handleConfirmationModalOk = () =>{
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    }

    const handleConfirmationModalCancel = () =>{
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    }

    const handleConfirmationModalClose = () =>{
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    }
    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const setArrangedClusterTripsFunc = (data) =>{
        setArrangedClusterTrips(data);
    };
    const handleTripActionsDialogueShowHide = (show) => {
        setGridRefreshPaused(show);
        setShowTripActionsDialog(show);
    }

    function ToolBoxStateChange(newToolboxValues){
        // console.log(newToolboxValues.AffiliatesList);
        sendAffToParent(newToolboxValues.AffiliatesList);
        SetToolboxValues({...ToolboxValues, ...newToolboxValues});

    }
    
    const GridRowSelect = (rowData) => {
        setSelectedRowData(rowData);
        gridRowData(rowData);
    }

    const handleMarkAsWillCall = async (rowData, modalBtn) => {
        try{
            let confirmation = (rowData.iRefID && rowData.iRefID !== "" ? parseInt(rowData.iRefID) : 0);
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowGridClusterLoader(true);
            let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/MarkTripAsWillCall", "post", {'Content-Type': 'application/json'}, confirmation,  xCancelSourceForGrid.current);
            console.log(response);
            setShowGridClusterLoader(false);
            if(response && response.error === "")
            {
                if(response.data && response.data !== "No data found")
                {
                    if(response.data === 1)
                    {
                        setModalHeaderText("Trip Status Changed");
                        setModalBodyHTML("Trip #"+rowData.iRefID+" was changed to 'Will Call' status successfully.");
                        setModalBtnHTML(modalBtn);
                        setShowDynamicModal(true);
                    }
                    else if(response.data === 0)
                    {
                        setModalHeaderText("Trip Status Alert");
                        setModalBodyHTML("Trip #"+rowData.iRefID+" was not marked as 'Will Call'.");
                        setModalBtnHTML(modalBtn);
                        setShowDynamicModal(true);
                    }
                    
                }
                else
                {
                    setModalHeaderText("Trip Status Alert");
                    setModalBodyHTML("No data was found for the trip #"+rowData.iRefID+", please try again or contact an administrator.");
                    setModalBtnHTML(modalBtn);
                    setShowDynamicModal(true);
                }
            }
            else
            {
                setModalHeaderText("Trip Status Error");
                setModalBodyHTML(<b>{response.error}</b>);
                setModalBtnHTML(modalBtn);
                setShowDynamicModal(true);
            }
        }
        catch(err){console.log(err);}
    };

    const AdjustRouteTimes = async () => {
        if(!showAlert){
            setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...' , displayFooter: false});
            setAlert(true);
            sethandlePageProgressBar("dispatch")
        }
        let StopViewMainData = ClusterTableObject.current.getData()[0];
        //let StopViewMainData = ClusterTableObject.current.getSelectedRows()[0].getData();
        const data = ClusterTableObject.current.getData();
        let _tripDetails = [];
        let _stopOrder = 1;
        let loopStartIndex = 0;
        let iMode= 0;
        if(StopViewSelectedRowIndex !== 0){
            iMode=16;
            // loopStartIndex= data.findIndex(row => row.Index === StopViewSelectedRowIndex);
        }
        for (var i = loopStartIndex; i < data.length; i++) {
            if (data[i].Type === "PU" || data[i].Type === "DO" || data[i].Type === "EndDept" || data[i].Type === "StartDept") {
                let det = {};
                det.RouteID = data[i].Route;
                det.iRefID = data[i]["TripNo"];
                if (det.iRefID === "" || det.iRefID === null || det.iRefID === undefined) {
                    det.iRefID = "-1"
                }
                det.NodeType = data[i].Type;
                det.SystemScheduleTime = data[i].SchTime;
                det.EstTravelTime = data[i].EstTimeFromPrev;
                det.EstTravelDistance = data[i].EstDistFromPrev;
                det.WaitTimeAtLocation = 0;
                //det.isNewNode = false;
                det.PUPerson = data[i].PUPerson;
                det.TripRequestStatus = data[i].StopStatus;
                det.ERSASettingName = "";
                det.ERSASettingID = _stopOrder;  //algoSettingId;
                det.Zone = "";
                //det.Latitude = array[i].dLatitude;
                //det.Longitude = array[i].dLongitude;
                det.isFeasibleRoute = false;
                det.PickupDateTime = data[i].ReqTimeHidden;
                det.ManifestNumber = data[i].ManifestNumber;
                if (det.NodeType === "EndDept" && _tripDetails.length > 0) {
                    det.SystemScheduleTime = data[i - 1].SchTime;
                    det.PickupDateTime = data[i - 1].ReqTimeHidden;
                    det.RouteID = data[i - 1].Route;
                }
                _tripDetails.push(det);
                _stopOrder++;
            }
        }
        if (_tripDetails.length === 1) {
            //ShowDialogueMsg("InValid Action", "Action not allowed.");
            return false;
        }
        
        let callBackURL = "";
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }


        let params = {
            "TripDetails" : JSON.stringify(_tripDetails),
            "callBackURL" : callBackURL,
            "iMode" : iMode, // 1 for COmpute Estimates Route on Cluster Table Grid/Stop View Screen
            "AlgoSetting" : String(StopViewMainData.iID_RouteGeneralSettings),   //String(StopViewMainData.iSettingID),
            "RouteNo" : StopViewMainData.Route,
            "iAffiliateID": String(StopViewMainData.iAffiliateID), //StopViewMainData.iATSPID,
            "iUserID": loginData.iUserID,
            "iSelectedRefID": SelectedRowRefID.current,
            "iStopType": SelectedRowStopType == "PU"? 0 : 1
        }
        
        xCancelSourceForGrid.current = APICom.GenerateSource();
        setShowGridClusterLoader(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/Routing/BulkInputToARB", "post", {}, params, xCancelSourceForGrid.current);
        if(response["data"] !== null && response["data"].length > 0){
            //to do
        }
        else{
            //to do
        }
        setShowGridClusterLoader(false);
    }

    const StopViewGridLoad  =  async (vManifestNumber, iAffiliateID) =>{
        handleRowResize(ClusterGridheight.current);
        let params = {
            "vManifestNumber":  vManifestNumber,
            "dtSelectedDate": RefSelectedDate.current, //"12/06/2023",
            "vehicleId": -1,
            "bIncludePerformed": false,
            "vAffIDs": String(iAffiliateID),
            "confirmationNo": "" ,
            "iFetchMode": 0,
            "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
            "iUserID": loginData.recordID
        }

        let response =  await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params,  null);
        let result = response.data;
        if(result !== null && result.data &&  result.data.length > 0){
            setShowGridClusterLoader(true);
            // setClusterGridResponse([]);
            setclusterTableStateBeforeCompute(null);
            setClusterGridResponse(result.data);
            setClusterGridColumnSetting(result.setting)
            routedTripShow.current ={"route":result.data[0]?.Route, "data":""};
        }
        setShowGridClusterLoader(false);
    }

    const AutoRefresh= async () =>{
        const checkbox = document.getElementById("clusterTableGrid_checkbox");
        if (checkbox.checked){
            someThingChangedInGrid.current = false;
        }else{
            someThingChangedInGrid.current = true;
        }
    }

    const ValidateRoute = async () =>{
        sethandlePageProgressBar("dispatch");
        setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...' , displayFooter: false});
        setAlert(true);
        

        let StopViewMainData = ClusterTableObject.current.getData()[0];
        const data = ClusterTableObject.current.getData();
        let _tripDetails = [];
        let _stopOrder = 1;
        for (var i = 0; i < data.length; i++) {
            if (data[i].Type === "PU" || data[i].Type === "DO" || data[i].Type === "EndDept") {
                let det = {};
                det.RouteID = data[i].Route;
                det.iRefID = data[i]["TripNo"];
                if (det.iRefID === "" || det.iRefID === null || det.iRefID === undefined) {
                    det.iRefID = "-1"
                }
                det.NodeType = data[i].Type;
                det.SystemScheduleTime = data[i].SchTime;
                det.EstTravelTime = data[i].EstTimeFromPrev;
                det.EstTravelDistance = data[i].EstDistFromPrev;
                det.WaitTimeAtLocation = 0;
                //det.isNewNode = false;
                det.PUPerson = data[i].PUPerson;
                det.TripRequestStatus = data[i].StopStatus;
                det.ERSASettingName = "";
                det.ERSASettingID = _stopOrder;  //algoSettingId;
                det.Zone = "";
                //det.Latitude = array[i].dLatitude;
                //det.Longitude = array[i].dLongitude;
                det.isFeasibleRoute = false;
                det.PickupDateTime = data[i].ReqTimeHidden;
                det.ManifestNumber = data[i].ManifestNumber;
                if (det.NodeType === "EndDept" && _tripDetails.length > 0) {
                    det.SystemScheduleTime = data[i - 1].SchTime;
                    det.PickupDateTime = data[i - 1].ReqTimeHidden;
                    det.RouteID = data[i - 1].Route;
                }
                _tripDetails.push(det);
                _stopOrder++;
            }
        }
        if (_tripDetails.length === 1) {
            let manageRouteFooterBtns = ["OK"];
            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                return(
                    <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {item}
                    </Button>
                );
            });
            setModalHeaderText("Validation Alert");
            setModalBodyHTML("Action not allowed.");
            setModalBtnHTML(manageRouteFooterHTML);
            setShowDynamicModal(true);
            // alert("InValid Action", "Action not allowed.");
            
            return false;
        }
        
        let callBackURL = "";
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }

        let params = {
            "TripDetails" : JSON.stringify(_tripDetails),
            "callBackURL" : callBackURL,
            "iMode" : 1, // 1 for Validate Route on Cluster Table Grid/Stop View Screen
            "AlgoSetting" : String(StopViewMainData.iID_RouteGeneralSettings),   //String(StopViewMainData.iSettingID),
            "RouteNo" : StopViewMainData.Route,
            "iAffiliateID": String(StopViewMainData.iAffiliateID), //StopViewMainData.iATSPID,
            "iUserID": loginData.iUserID
        }
        
        xCancelSourceForGrid.current = APICom.GenerateSource();
        setShowGridClusterLoader(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/Routing/BulkInputToARB", "post", {}, params, xCancelSourceForGrid.current);
        if(response["data"] !== null && response["data"].length > 0){
            //to do
        }
        else{
            //to do
        }
        setShowGridClusterLoader(false);

    }

    const CommitActions = async () =>{
        try {
            handleRowResize(ClusterGridheight.current);
            setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...' , displayFooter: false});
            setAlert(true);
            let StopViewMainData = ClusterTableObject.current.getData()[0];
            //let StopViewMainData = ClusterTableObject.current.getSelectedRows()[0].getData();
            const _result = ClusterTableObject.current.getData();
            var Result = [];
            var arrayTripClusterGrid  = _result.filter(
                (v) =>
                  v.Type === 'PU' ||
                  v.Type === 'DO' ||
                  v.Type === 'StartDept' ||
                  v.Type === 'EndDept');

            if (arrayTripClusterGrid.length > 0) {
                //Changes To Restict The Commit Action For The External Trips
                var _ExternalList = arrayTripClusterGrid.filter(el => el.iCreatedByAppId === 19);

                if (_ExternalList != null && typeof _ExternalList != "undefined" && _ExternalList.length > 0) {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={()=>setShowDynamicModal(false)}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText("Commit Action Alert");
                    setModalBodyHTML("Action not Allowed for the Broker Trips.");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowDynamicModal(true);
                    // console.log("Action not Allowed for the Broker Trips.");
                    return false;
                }
                var _affilateId = StopViewMainData.iAffiliateID;
                

                let rsfc_input = null;
                var RSFCRoutes = new Array();
                let _iStopNumberCount = 1;
                let routeTypeMode = 1;
                // arrayTripClusterGrid.sort((a, b) => a["Stop#"] - b["Stop#"]);
                //Changes To Restict The Commit Action For The External Trips
                for (var i = 0; i < arrayTripClusterGrid.length; i++) {
                    var _ConfirmationNo = arrayTripClusterGrid[i]["TripNo"];
                    var _stoptype = arrayTripClusterGrid[i]["Type"];
                    if (_stoptype === "StartDept" || _stoptype === "EndDept") {
                        routeTypeMode = 2
                    }
                    if (_ConfirmationNo !== "" && typeof _ConfirmationNo !== "" &&
                        (_stoptype === "PU" || _stoptype === "DO" || _stoptype === "StartDept" || _stoptype === "EndDept")) 
                    {
                        var isfound = true;
                        var _objT = {
                            "vManifestNumber": arrayTripClusterGrid[i]["ManifestNumber"],
                            "iTripID": parseInt(arrayTripClusterGrid[i]["TripNo"]),
                            "iStopNumber": _iStopNumberCount,
                            "vStopType": arrayTripClusterGrid[i]["Type"],
                            "vReferenceNo": "",
                            "dtSchTime": arrayTripClusterGrid[i]["SchTime"],
                            "bWillCall": arrayTripClusterGrid[i]["bWillCall"],
                            "bPerformed": arrayTripClusterGrid[i]["bPerformed"],
                            "bIsScheduled": arrayTripClusterGrid[i]["bIsScheduled"] ?? "",
                            "dtReqTime": arrayTripClusterGrid[i]["ReqTime"],
                            "SchDateTime": arrayTripClusterGrid[i]["SchDateTime"]
                        };
                        Result.push(_objT);
                        _iStopNumberCount++;
                        try {
                            var temp_elem = RSFCRoutes.findIndex(elem => elem.ManifestNumber === arrayTripClusterGrid[i]["ManifestNumber"]);
                            if (temp_elem < 0 && arrayTripClusterGrid[i]["ManifestNumber"] !== "")
                                RSFCRoutes.push({ "ManifestNumber": arrayTripClusterGrid[i]["ManifestNumber"], "RouteType": routeTypeMode });
                        } catch (error) { }
                    }
                }
                if (Result !== null && Result.length > 0) {
                    var _iUserID = 0;
                    if (loginData !== null && typeof loginData !== "undefined") {
                        _iUserID = loginData.iUserID
                    }

                    let MACsAPI_URL = "";
                    let RunRSFC_URL = "";
                    if (GlobalASCSData !== null && GlobalASCSData !== undefined) {

                        MACsAPI_URL = GlobalASCSData.find(item => item.SubTitle === "MACsAPI_URL").value;

                        let localURLItem = GlobalASCSData.find(item => item.SubTitle === "InLoadAPI_LocalURL");

                        if (localURLItem) {
                            RunRSFC_URL = localURLItem.value;
                        } else {
                            let apiUrlItem = GlobalASCSData.find(item => item.SubTitle === "InLoadAPI_URL");
                            RunRSFC_URL = apiUrlItem ? apiUrlItem.value : null;
                        }
                        
                    }

                    var jsondata = { 
                        "DataList": JSON.stringify(Result),
                        "iModifiedBy": _iUserID,
                        "vManifestDisposition": "RASA" ,
                        "MACsAPI_URL" : MACsAPI_URL+'/MBPC/CommonAPICall?MethodName=SaveUpdateRouteStopsOrder',
                        "iModifiedByAppID": 26,
                        "vHistoryReason": HistoryReason.current,
                        "IrefIDForUpdateSchedule": SelectedRowRefID.current,
                        "RunRSFC_URL": RunRSFC_URL+'/MBPC/RunRSFC',
                        "RSFC_Routes": RSFCRoutes
                        }

                    try {
                        rsfc_input = { "Routes": RSFCRoutes, "UnRoutedTrips": null, UserID: _iUserID, AppID: 26 };
                   
                    
    
                        xCancelSourceForGrid.current = APICom.GenerateSource();

                        let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/Routing/CommitAdjustedRoutes", "post", {}, jsondata);
                        
                        if (response.data === 'success') {

                            // var rsfc_response = await APICom.fetchData("full", `${RunRSFC_URL}/MBPC/RunRSFC`, "post", {}, rsfc_input);


                            // if (rsfc_response.data.GenericRecord === ''){}
                                setAlert(false);
                                setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Manual Route Adjustment', body:'Changes Saved Sucessfully', btnCancelText: 'No', btnOkText: 'Ok'}));

                                let params = {

                                    "vManifestNumber": StopViewMainData.ManifestNumber,
                                    "dtSelectedDate": RefSelectedDate.current, //"12/06/2023",
                                    "vehicleId": -1,
                                    "bIncludePerformed": false,
                                    "vAffIDs": String(StopViewMainData.iAffiliateID),
                                    "confirmationNo": String(StopViewMainData.ConfirmationNo),
                                    "iFetchMode": 0,
                                    "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
                                    "iUserID": loginData.recordID
                                }
                    
                                // xCancelSourceForGrid.current = APICom.GenerateSource();
                                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params,  null);
                                let result = response.data;
                                if(result !== null && result.data &&  result.data.length > 0)
                                {
                                    setShowGridClusterLoader(true);
                                    // setClusterGridResponse([]);
                                    setclusterTableStateBeforeCompute(null);
                                    setClusterGridResponse(result.data);
                                    setClusterGridColumnSetting(result.setting)
                                    
                                    routedTripShow.current ={"route":result.data[0]?.Route, "data":""};
                                }
                                setShowGridClusterLoader(false);
                        
                        }

                        else if(response.data.message && response.data.message !== ""){
                            setAlert(false);
                            const errorMessage = response.data.message;
                            setAlertObj({ ...routeObj, alertTitle: 'Commit Action', alertMsg: errorMessage , displayFooter: true});
                            setAlert(true);
                        }

                        else{
                            setAlert(false);
                            const errorMessage = "An error occured while committing";
                            setAlertObj({ ...routeObj, alertTitle: 'Commit Action', alertMsg: errorMessage , displayFooter: true});
                            setAlert(true);

                        }
                    }

                    catch (error) { }

                }
                else {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={()=>setShowDynamicModal(false)}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText("Commit Action Alert");
                    setModalBodyHTML("No change found in any record !");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowDynamicModal(true);
                    // console.log("No change found in any record !");
                    return false;
                }
            }
            else {
                let manageRouteFooterBtns = ["OK"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={()=>setShowDynamicModal(false)}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Commit Action Alert");
                setModalBodyHTML("There are no records to update.");
                setModalBtnHTML(manageRouteFooterHTML);
                setShowDynamicModal(true);
                // console.log("There are no records to update.");
                return false;
            }
        
        }
        catch (TripClusterCommit) { console.log(TripClusterCommit); }
    }

    const handleColorCodesDisplay = async (affiliate) => {
        try {
            let iATSPID = loginData ? loginData.iUserAffiliateID.toString() : "-1" ;
            //(ToolboxValues.AffiliatesList === "" ? iATSPID :ToolboxValues.AffiliatesList.split(',')[0].trim(' '))
            let data = {
                "iATSPID": affiliate
            }
            let response = await APICom.fetchData("", "TripActions/GetServiceRequestColorCodes", "post", { "Content-Type": "application/json" }, data, null);
            let api_data = response.data.data ? response.data.data : []
            // Elvis operator in ECMAScript 2020
            if (api_data?.length) {
                if (api_data.length === 3)
                {
                    //setApiRowData(api_data[0]);
                    setApiColData(api_data[1]);
                    setApiAttributesColors(api_data[2]);
                }

            }
            
        }
        catch (err) { console.log(err); }
    }

    const handleClusterManifestData = async (data, checked) => {
        try {
            if(data)
            {
                handleRowResize(ClusterGridheight.current);
                let data1 = mainTableObj.current.getData();
                const filteredResults = data1.filter(item => item.vManifestNumber === data.vManifestNumber);
                filteredResults.sort((a, b) => {
                    const timeA = new Date(a.PickupDateTime);
                    const timeB = new Date(b.PickupDateTime);
                    return timeA - timeB;
                });

                xCancelSourceForGrid.current = APICom.GenerateSource();
                
    
                let params = {
    
                    "vManifestNumber": data.vManifestNumber,
                    "dtSelectedDate": RefSelectedDate.current, //"12/06/2023",
                    "vehicleId": -1,
                    "bIncludePerformed": checked,
                    "vAffIDs": String(data.PrimaryAffiliateID),
                    "confirmationNo": String(data.ConfirmationNo),
                    "iFetchMode": 0,
                    "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
                    "iUserID": loginData.recordID
                }
                
                // xCancelSourceForGrid.current = APICom.GenerateSource();
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params,  null);
                let result = response.data;
                if(result !== null && result.data && result.data.length > 0)
                {

                    // if(filteredResults[0]?.ServiceStatus?.toUpperCase() === "ACTIVE" || filteredResults[0]?.ServiceStatus.toUpperCase() === "ASSIGNED" || filteredResults[0]?.ServiceStatus.toUpperCase() === "TRANSFERRED")
                    // {
                    //     let APIdata = {
                    //         "pulat": filteredResults[0]?.PickupLatitude,
                    //         "pulong": filteredResults[0]?.PickupLongitude,
                    //         "nwheelchairs": String(filteredResults[0]?.nTotalWheelChairs),
                    //         "iatspid": String(filteredResults[0]?.iSRATSPID),
                    //         "bshowoccupiedvehicles": "false",
                    //         "irefid": String(filteredResults[0]?.iRefID),
                    //     }
                    //     await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                    //         setVehData(response.data);
                    //     });
                    // }
                    if (data.ServiceStatus?.toUpperCase() === "DISPATCHED" || data.ServiceStatus.toUpperCase() === "IRTPU" || data.ServiceStatus.toUpperCase() === "PICKEDUP" || 
                    data.ServiceStatus.toUpperCase() === "ATLOCATION" || data.ServiceStatus?.toUpperCase() === "ASSIGNED"){
                        let APIdata = {
                            "iServiceID": data.ServiceID,
                        }
                        await APICom.fetchData("main", "TripActions/GetVehicleAssignedToTrip", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                            setVehData([])
                            setVehData(response.data);
                        });
                    };

                    setShowGridClusterLoader(true);
                    // setClusterGridResponse([]);
                    setclusterTableStateBeforeCompute(null);
                    setClusterGridResponse(result.data);
                    setClusterGridColumnSetting(result.setting)
                    
                    routedTripShow.current ={"route":result.data[0]?.Route, "data":""};
                    
                }
                setShowGridClusterLoader(false);
            }
        }
        catch (err) { console.log(err); }
    }
    const GridRowDoubleClick = async(data, autoDoubleClick=false) => {
        try{
            if(autoDoubleClick){
                setMapViewFromDoubleClick(false)
            }else{
                setMapViewFromDoubleClick(true)
            }

            handleRowResize(ClusterGridheight.current);
            // someThingChangedInGrid.current = false;
            let pickupFullAddress = "";
            let dropoffFullAddress = "";
            let riderName = "";
            let scheduledPUTime = "";
            let scheduledDOTime = "";
            setVehData([]);
            let bIsSelectedTripWithIn30Mins = true;
            try{
                let SelectedRowDateTime = new Date();
                SelectedRowDateTime = CommonFunctions.ParseFormatADate(data.PickupDateTime.replace(/ {2}/g, ' '));
                if (Object.prototype.toString.call(SelectedRowDateTime) === "[object Date]") {
                    // it is a date
                    if (isNaN(SelectedRowDateTime)) { // d.getTime() or d.valueOf() will also work
                    // date object is not valid
                    SelectedRowDateTime = new Date();
                    } else {
                    // date object is valid
                    }
                } else {
                    // not a date object
                    SelectedRowDateTime = new Date();
                }
                bIsSelectedTripWithIn30Mins = CommonFunctions.isDateWithinFuture30Minutes(SelectedRowDateTime);
            }
            catch(tr) { bIsSelectedTripWithIn30Mins = true;}
            if(data.Route !== undefined)
            {
                riderName = "";
                scheduledPUTime = "";
                scheduledDOTime = "";
                pickupFullAddress = data.PickupAddress;
                dropoffFullAddress = data.Destination;
                if(data.PickupPerson === "")
                {
                    riderName = "UNKWN";
                }
                else
                {
                    let nameSplit = data.PickupPerson.split(",");
                    riderName = nameSplit[(nameSplit.length-1)] + " ";
                    for(let i = 0; i < nameSplit.length; i++)
                    {
                        if(i < (nameSplit.length - 1))
                        {
                            riderName += nameSplit[i] + " ";
                        }
                    }
                }
                if(data.PickupTime !== "" && data.PickupTime !== null)
                {
                    if(data.PickupTime.indexOf(':') > -1)
                    {
                        scheduledPUTime = data.PickupTime;
                    }
                    else
                    {
                        scheduledPUTime = data.PickupTime;
                    }
                }
                else
                {
                    scheduledPUTime = "N/A";
                }
                if(data.ApptTime !== "" && data.ApptTime !== null)
                {
                    if(data.ApptTime === "00:00")
                    {
                        scheduledDOTime = "24:00";
                    }
                    else
                    {
                        scheduledDOTime = data.ApptTime;
                    }
                }
                else
                {
                    scheduledDOTime = "N/A";
                }
    
                if(selectRowData.length <= 0)
                {
                    selectRowData.push(data);
                }
                
                // let data1 = mainTableObj.current.getData();
                // const filteredResults = data1.filter(item => item.vManifestNumber === data.vManifestNumber);
                // filteredResults.sort((a, b) => {
                //     const timeA = new Date(a.PickupDateTime);
                //     const timeB = new Date(b.PickupDateTime);
                //     return timeA - timeB;
                // });
                xCancelSourceForGrid.current = APICom.GenerateSource();
                if(bIsSelectedTripWithIn30Mins && (data.ServiceStatus.toUpperCase() === "ACTIVE" || data.ServiceStatus.toUpperCase() === "ASSIGNED" || data.ServiceStatus.toUpperCase() === "TRANSFERRED"))
                {
                    let APIdata = {
                        "pulat": data.PickupLatitude,
                        "pulong": data.PickupLongitude,
                        "nwheelchairs": String(data.nTotalWheelChairs),
                        "iatspid": String(data.iSRATSPID),
                        "bshowoccupiedvehicles": "false",
                        "irefid": String(data.iRefID),
                    }
                    await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                        setVehData(response.data);
                    });
                }
                else if (data.ServiceStatus.toUpperCase() === "DISPATCHED" || data.ServiceStatus.toUpperCase() === "IRTPU" || data.ServiceStatus.toUpperCase() === "PICKEDUP" || data.ServiceStatus.toUpperCase() === "ATLOCATION"){
                    let APIdata = {
                        "iServiceID": data.ServiceID,
                    }
                    await APICom.fetchData("main", "TripActions/GetVehicleAssignedToTrip", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                        setVehData(response.data);
                    });
                };
                let tempMapArr = [];
                tempMapArr.push({Action: ["",""], vManifestNumber: data.vManifestNumber, Custom: "", 
                    VehicleNum: data.VEHNo, nTotalWheelChairs: data.nTotalWheelChairs, TripStatus: data.TripRequestStatus, 
                    ETA: [(data.PUETA === ""? data.SchedulePickTime: data.PUETA), (data.DOETA === "" ? data.ScheduleDropTime: data.DOETA)], 
                    TSPID: data.iSRATSPID, ConfirmationNo: data.ConfirmationNo, Route: data.Route, pickupFullAddress: (pickupFullAddress +" "+ data.PickupZip), 
                    dropoffFullAddress: (dropoffFullAddress +" "+ data.DropZip), PUPerson: riderName, scheduledPUTime: scheduledPUTime, scheduledDOTime: scheduledDOTime, 
                    pickLat: data.PickupLatitude, pickLng: data.PickupLongitude, dropLat: data.DropLatitude, dropLng: data.DropLongitude}
                );
                setMapDetailData(tempMapArr);
                let params = {
                    "vManifestNumber": data.vManifestNumber,
                    "dtSelectedDate": RefSelectedDate.current, //"12/06/2023",
                    "vehicleId": -1,
                    "bIncludePerformed": false,
                    "vAffIDs": String(data.PrimaryAffiliateID),
                    "confirmationNo": String(data.ConfirmationNo),
                    "iFetchMode": 1,
                    "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
                    "iUserID": loginData.recordID
                }
    
                // xCancelSourceForGrid.current = APICom.GenerateSource();
                // setShowGridLoader(true);
                setClusterGridResponse([]);
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params,  null);
                let result = response.data;
                if(result !== null && result.data && result.data.length > 0)
                { 
                    //Column name change because grid control accept only TripNo, Stop#, Type otherwise Grid wont show
                    // let tripResult = [];
                    // result.forEach(item => {
                    //     if(item["TripNo"] === data.ConfirmationNo)
                    //     {

                    //         // item["TripNo"] = item["Confirmation #"];
                    //         // item["Stop#"] = item["StopOrder"];
                    //         // item["Type"] = item["StopType"];

                    //         //item["Index"] = item["TripNo"] + "_" + item["Type"];
                        
                    //         // If you want to delete the old column names, you can use the following lines:
                    //         // delete item["Confirmation #"];
                    //         // delete item["StopOrder"];
                    //         // delete item["StopType"];
                        
                    //         tripResult.push(item);
                    //     }
                    // });
                    // result = result.map(record => ({ ...record, Action: 'Up Arrow' }));
                    // setMapDetailData(result);
                    unroutedTripShow.current.unroutedTripConf = result.data[0]?.TripNo;
                    unroutedTripShow.current.data = "";
                    setclusterTableStateBeforeCompute(null);
                    setClusterGridResponse(result.data);
                    setClusterGridColumnSetting(result.setting);
                }
                
            }
            else
            {
                if(selectRowData.length <= 0)
                {
                    selectRowData.push(data);
                }
                
                data.sort(function(a,b){                                              //Sorted
                    return a.PickupTime.localeCompare(b.PickupTime);
                });
                
                let data1 = mainTableObj.current.getData();
                const filteredResults = data1.filter(item => item.vManifestNumber === data.vManifestNumber);
                filteredResults.sort((a, b) => {
                    const timeA = new Date(a.PickupDateTime);
                    const timeB = new Date(b.PickupDateTime);
                    return timeA - timeB;
                });

                xCancelSourceForGrid.current = APICom.GenerateSource();
    
                if(bIsSelectedTripWithIn30Mins && (filteredResults[0]?.ServiceStatus.toUpperCase() === "ACTIVE" || filteredResults[0]?.ServiceStatus.toUpperCase() === "ASSIGNED" || filteredResults[0]?.ServiceStatus.toUpperCase() === "TRANSFERRED"))
                {
                    let APIdata = {
                        "pulat": filteredResults[0]?.PickupLatitude,
                        "pulong": filteredResults[0]?.PickupLongitude,
                        "nwheelchairs": String(filteredResults[0]?.nTotalWheelChairs),
                        "iatspid": String(filteredResults[0]?.iSRATSPID),
                        "bshowoccupiedvehicles": "0",
                        "irefid": String(filteredResults[0]?.iRefID),
                    }
                    await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                        setVehData(response.data);
                    });
                }
                else if (data[0].ServiceStatus.toUpperCase() === "DISPATCHED" || data[0].ServiceStatus.toUpperCase() === "IRTPU" || data[0].ServiceStatus.toUpperCase() === "PICKEDUP" || data[0].ServiceStatus.toUpperCase() === "ATLOCATION"){
                    let APIdata = {
                        "iServiceID": data[0].ServiceID,
                    }
                    await APICom.fetchData("main", "TripActions/GetVehicleAssignedToTrip", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                        setVehData(response.data);
                    });
                };
                
                let newMapArray = [];
                for(let j = 0; j < data.length; j++)
                {
                    pickupFullAddress = "";
                    dropoffFullAddress = "";
                    riderName = "";
                    scheduledPUTime = "";
                    scheduledDOTime = "";
                    pickupFullAddress = data[j].PickupAddress;
                    dropoffFullAddress = data[j].Destination;
                    if(data[j].PickupPerson === "")
                    {
                        riderName = "UNKWN";
                    }
                    else
                    {
                        let nameSplit = data[j].PickupPerson.split(",");
                        riderName = nameSplit[(nameSplit.length-1)] + " ";
                        for(var i = 0; i < nameSplit.length; i++)
                        {
                            if(i < (nameSplit.length - 1))
                            {
                                riderName += nameSplit[i] + " ";
                            }
                        }
                    }
                    if(data[j].PickupTime !== "" && data[j].PickupTime !== null)
                    {
                        if(data[j].PickupTime.indexOf(':') > -1)
                        {
                            scheduledPUTime = data[j].PickupTime;
                        }
                        else
                        {
                            scheduledPUTime = data[j].PickupTime;
                        }
                    }
                    else
                    {
                        scheduledPUTime = "N/A";
                    }
                    if(data[j].ApptTime !== "" && data[j].ApptTime !== null)
                    {
                        if(data[j].ApptTime === "00:00")
                        {
                            scheduledDOTime = "24:00";
                        }
                        else
                        {
                            scheduledDOTime = data[j].ApptTime;
                        }
                    }
                    else
                    {
                        scheduledDOTime = "N/A";
                    }
                    newMapArray.push({Action: ["<img class='float-start' id='"+data[j]["ConfirmationNo"]+"_PU_UP_rearrangeClusterTrips' style='cursor:pointer !important;' title='Move P"+(j+1)+ " Up' src='"+arrowUp+"'><img class='float-end' id='"+data[j]["ConfirmationNo"]+"_PU_DOWN_rearrangeClusterTrips' style='cursor:pointer !important;' title='Move P"+(j+1)+ " Down' src='"+arrowDown+"'>","<img class='float-start' id='"+data[j]["ConfirmationNo"]+"_DO_UP_rearrangeClusterTrips' style='cursor:pointer !important;' title='Move D"+(j+1)+ " Up' src='"+arrowUp+"'><img class='float-end' id='"+data[j]["ConfirmationNo"]+"_DO_DOWN_rearrangeClusterTrips' style='cursor:pointer !important;' title='Move D"+(j+1)+ " Down' src='"+arrowDown+"'>"], 
                    vManifestNumber: data[j].vManifestNumber, Custom: "", VehicleNum: data[j].VEHNo, nTotalWheelChairs: data[j].nTotalWheelChairs, 
                    StopStatus: data[j].TripRequestStatus, ETA: [(data[j].PUETA === ""? data[j].SchedulePickTime: data[j].PUETA), (data[j].DOETA === "" ? data[j].ScheduleDropTime: data[j].DOETA)], 
                    TSPID: data[j].iSRATSPID, ConfirmationNo: data[j].ConfirmationNo, Route: data[j].Route, pickupFullAddress: (pickupFullAddress +" "+ data[j].PickupZip), 
                    dropoffFullAddress: (dropoffFullAddress +" "+ data[j].DropZip), PUPerson: riderName, scheduledPUTime: scheduledPUTime, scheduledDOTime: scheduledDOTime, 
                    pickLat: data[j].PickupLatitude, pickLng: data[j].PickupLongitude, dropLat: data[j].DropLatitude, dropLng: data[j].DropLongitude});
                }
                setMapDetailData(newMapArray);
            }
        }
        catch(err){console.log(err);}
    }

    const PrepareClusterGridRequest = async () => {}

    const timerRef = useRef(null);
    const PrepareGridRequest = async () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            setTimeTakenByLastGridCall(0);
            APICom.LastGridCall = new Date();
            if(ToolboxValues.Date === "" || ToolboxValues.AffiliatesList === ""){return; }

            if (ToolboxValues.Date !== ""){
                RefSelectedDate.current = ToolboxValues.Date; //saving DOM selected date because we need this when showing cluster grid. If not saved here it shows empty date
            }
            DispatchGridControlRef.current.ToolboxUpdate(ToolboxValues);
        }, 1000);
        return;
        try {
            
            if(xCancelSourceForGrid.current != null) { 
                xCancelSourceForGrid.current.cancel("Cancelling grid request fetch call before initiating new request");
            }
        } catch(e) { }
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let iRoutedTrip = 0;
        try{
            if(ToolboxValues.Grouping === ""){
                iRoutedTrip = 0;
            }
            else if(ToolboxValues.Grouping.indexOf(",") < 0) {
                iRoutedTrip = parseInt(ToolboxValues.Grouping);
            }
        }
        catch(e) { }
        const data = {
            "date": ToolboxValues.Date,
            "aff_list": (ToolboxValues.AffiliatesList === "" ? "999" : ToolboxValues.AffiliatesList),
            "FSList": ToolboxValues.FSList,
            "user_id": loginData.recordID,
            "statusArr": ToolboxValues.StatusList,
            "attrArray": ToolboxValues.AttrList,
            "iRoutedTrip": iRoutedTrip,
            "ihoursInFuture": ToolboxValues.TotalHours,
            "SendJSONResponse": true,
            "user_name": loginData.vUserName
        }
        setShowGridLoader(true);
        
        // console.log("Grid Data Reloaded from dispatch");
        iDispatchRequestCountUnderProgress.current = iDispatchRequestCountUnderProgress.current  + 1;
        APICom.fetchData("main", "GridData/GetSRQARQPRQGridData", "post", {}, data, xCancelSourceForGrid.current).then((response) => {
            setNetworkTimeTakenByLastGridCall((new Date()) - APICom.LastGridCall);
            APICom.LastGridCall = new Date();
            iDispatchRequestCountUnderProgress.current = iDispatchRequestCountUnderProgress.current  - 1;
            if(iDispatchRequestCountUnderProgress.current <= 0){
                setShowGridLoader(false);
            }
            if(response.error === ""){
                setDispatchGridResponse({"data" : response.data});
            }
            else{
            }
        });
        
    }
    const handleSelectedRouteChange = (value)=>{
        manifestDataReceivedCheckRef.current = true;
        routedTripShow.current = {"route":value, "data":""};
        setselectedManifest(value);
        handleRowResize(ClusterGridheight.current);
    };

    const handleDropDownRouteChange = (route)=>{
        try {
            //someThingChangedInGrid.current = true;
            DropDownRouteValue.current = route;
            selectedTripInfoToRefreshGrid.current = null
        
        }
        catch (err) { console.log(err); }
        
    };

    const handler = (e) => {
        // e.preventDefault();
        if ( (e.key === 'x' || e.key === 'X')  && e.ctrlKey) { //Cancel & Activate: CTRL + X
            if(mainTableObj.current.getHeaderFilters().length === 0)
            {
                e.preventDefault();
                let tripStatusCollection = [];
                for(var k = 0; k < selectRowData.length; k++)
                {
                    tripStatusCollection.push(selectRowData[k].TripRequestStatus.toUpperCase());
                }
    
                if(tripStatusCollection.includes("NOSHOW") || tripStatusCollection.includes("NOSHOWED") || tripStatusCollection.includes("CANCELLED") || tripStatusCollection.includes("CANCELLEDARQ") || tripStatusCollection.includes("CANCELLEDSRQ"))
                {
                    if (!showActivateDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                        setShowActivateDialog(true);
                    }
                }
                else
                {
                    if (!showCancel && document.getElementsByClassName("modal-dialog").length === 0) {
                        setShowCancel(true);
                    }
                }
            }
            
            
        }
        // else if ((e.key === 'a' || e.key === 'A') && e.altKey){ //Activate: Alt + A
       
        // }
        
        // else if ((e.key === 'h' || e.key === 'H') && e.altKey){ //Trip History: Alt + H
        //     if (!showTripHistoryDialog && document.getElementsByClassName("modal-dialog").length === 0) {
        //         showTripHistoryDialog(true);
        //     }
        // }
        else if ((e.key === 'g' || e.key === 'G') && e.ctrlKey){ //Grouping: Ctrl + G
            e.preventDefault();
            if (!showGroupingDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                setShowGroupingActionDialog(true);
            }
        }
        else if ((e.key === 'q' || e.key === 'Q') && e.ctrlKey){ //Clustering: Ctrl + Q
            e.preventDefault();
            if (!showClusteringDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                setShowClusterDialog(true);
            }
        }
        else if ((e.key === 'b' || e.key === 'B') && e.ctrlKey){ //Broker: Ctrl + B
            e.preventDefault();
            if (!showBrokerActionsDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                setBrokerActionsDialog(true);
            }
        }
        else if ((e.key === 'd' || e.key === 'D') && e.ctrlKey){ //Trip Actions: Ctrl + D
            e.preventDefault();
            if (!showTripActionsDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                setShowTripActionsDialog(true);
            }
        }
        else if ((e.key === 'i' || e.key === 'I') && e.ctrlKey){ //Trip Info: CTRL + I
            e.preventDefault();
            if (!showTripDetailsDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                let selectedRows = mainTableObj.current.getSelectedRows();
                if(selectedRows.length > 1)
                {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"Please select a single trip to edit."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                        {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else if(selectedRows.length === 1)
                {
                    PersistStorage.save("IsTripDetailsDialogOpened", true, 10, false);
                    setTripDetailsDialog(true);
                }
            }
        }
    };
    const UnMountAgileDispatch = () => {
        setShowAgileDispatch(false);
    }

    const handleClusterGridResponse = () => {
        console.log("reload");
    };
    const [numOfTripsInRoute, setNumTripsInRoute] = useState("");
    useEffect(() => {
        if (mainTableObj?.current){
            let data = mainTableObj?.current.getData()
            let vRoute = selectRowData[0]?.Route
            const filteredNumbers = data.filter(row => row?.Route == vRoute);
            setNumTripsInRoute(filteredNumbers.length)
        }
        window.addEventListener('keydown', handler, false);
        return () => window.removeEventListener('keydown', handler, false);
        
    }, [selectRowData, mainTableObj]);

    useEffect(()=>{
        // if(!mapView)
        // {
        //     // setClusterGridResponse([]);
        //     // setMapDetailData([]);
        //     // setArrangedClusterTrips([]);
        // }
        mapViewCheck.current = mapView;
        // someThingChangedInGrid.current = false;

    },[mapView]);

    useEffect(()=>{
        if (rowMoveFlag){
            someThingChangedInGrid.current = true;
            updateCheckboxState();
            setRowMoveFlag(false);
        }
    },[rowMoveFlag]);

    function updateCheckboxState() {
        const checkbox = document.getElementById('clusterTableGrid_checkbox');
        if (checkbox) {
            if(checkbox.checked === true){
                console.log("Uncheced made true")
                checkbox.checked = false; // true to check, false to uncheck
            }
            
        }
        
    }

    // useEffect(() => {
    //     handleColorCodesDisplay();
    // }, []);

    useEffect(() => {
        setGroupingHeaderFilter(groupingHeaderFilter);
        groupingFilterCheck.current = groupingHeaderFilter;
    }, [groupingHeaderFilter]);

    useEffect(() => {
        try{
            let pliststyles = "";
            for (const AttributesColor of apiAttributesColors) {
                // console.log(AttributesColor);
                pliststyles = pliststyles + "      [Attr" + AttributesColor["ID"] + "]{margin-bottom: 1%;margin-left: 2px !important;background-color: " + AttributesColor["BackgroundColor"] + " !important;color: " + AttributesColor["vForeColor"] + " !important;display: inline-block !important; border:1px solid gray;}";
            }
            setDynamicsStyles(pliststyles);
        }
        catch(lp) { }
    }, [apiAttributesColors]);

    useEffect(() => {
        /*if(ToolboxValues.AffiliatesList && ToolboxValues.AffiliatesList !== "" && !ToolboxValues.AffiliatesList.includes(",") 
            && JSON.stringify(toolBoxRef.current) !== JSON.stringify(ToolboxValues)
        )
        {
            handleColorCodesDisplay(ToolboxValues.AffiliatesList);
        }*/
        toolBoxRef.current = ToolboxValues;
        PrepareGridRequest();
    }, [ToolboxValues]);

    useEffect(() => {
        if(mainTableObj.current && manifestDataReceivedCheckRef.current)
        {
            manifestDataReceivedCheckRef.current = false;
            if(selectedManifest !== "")
            {
                let data = mainTableObj.current.getData();
                let row = data.find((item)=>item.vManifestNumber === selectedManifest);
                selectedTripInfo.current = row;
                // handleClusterManifestData(row, checkboxSelectionFlag.current);
            }
        }
    },[manifestDataReceivedCheckRef.current]);

    useEffect(() => {
        if(document.readyState === 'complete')
        {
            // PersistStorage.save("rowDataCallAgent", [], 999, true);
            PersistStorage.save("rowDataEditTrip", "", 999, true);
            PersistStorage.save("clientInfo", [], 99, true);
            localStorage.removeItem("callAgentTabStatus");

        }
        return () => {
            try {
                if(xCancelSourceForGrid.current !== null){
                    xCancelSourceForGrid.current.cancel("Cancelling grid request fetch call before initiating new request");
                }
            } catch(e) { }
        };
      }, []);


      useEffect(() => {
        if(ARBResponseForStopViewComputeEstimates.length != null && ClusterTableObject.current != null)
        {
        let _driverBreakStart = null;
        let _driverBreakEnd = null;

        let _tempGridData = ClusterTableObject.current.getData();
        for (let d = 0; d < _tempGridData.length; d++) {
            if (_tempGridData[d]["Type"] == "DriverBreakStart") {
                _driverBreakStart = _tempGridData[d];
            } else if (_tempGridData[d]["Type"] == "DriverBreakEnd") {
                _driverBreakEnd = _tempGridData[d];
            }
        }

        if (_driverBreakEnd != null) {
            ClusterTableObject.current.deleteRow(_driverBreakEnd.Index);
        }
        if (_driverBreakStart != null) {
            ClusterTableObject.current.deleteRow(_driverBreakStart.Index);
        }

        let _allRowsGrid2 = ClusterTableObject.current.getData();

            for (var k = 0; k < _allRowsGrid2.length; k++) {
                for (var i = 0; i < ARBResponseForStopViewComputeEstimates.length; i++) 
                {
                    if (_allRowsGrid2[k].Index == ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"]) 
                    {
                        if (ARBResponseForStopViewComputeEstimates[i]["WaitTimeAtLocation"] <= 5) {
                            if (k > 0 && _allRowsGrid2[k - 1]["Type"] == "IdleTime") {
                                ClusterTableObject.current.deleteRow(_allRowsGrid2[k - 1].Index);
                            }
                        }
                        if (ARBResponseForStopViewComputeEstimates[i]["WaitTimeAtLocation"] > 5) {
                            let _idleTimeData = {};
                            _idleTimeData["Action"] = i + "";
                            _idleTimeData["TripNo"] = i + "_";
                            _idleTimeData["SchTime"] = moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).add(-1, 'minutes').format('HH:mm');
                            _idleTimeData["SchDateTime"] = moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).add(-1, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
                            _idleTimeData["Type"] = "IdleTime";
                            _idleTimeData["vStylCondDev"] = "IdleTime";
                            _idleTimeData["IdleTime"] = ARBResponseForStopViewComputeEstimates[i]["WaitTimeAtLocation"];
                            _idleTimeData["Index"] = i + "_IdleTime";
                            if (k > 0 && _allRowsGrid2[k - 1]["Type"] != "IdleTime") {
                                //add new row above existing row with index of ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + responseData[i]["NodeType"]
                                ClusterTableObject.current.addRow(_idleTimeData, true, ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"]);
                            } 
                            else {

                                ClusterTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], {["SchTime"]:_idleTimeData["SchTime"]});
                                ClusterTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], {["SchDateTime"]:_idleTimeData["SchDateime"]});
                                ClusterTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], {["IdleTime"]: _idleTimeData["IdleTime"]});
                            

                            }


                        }
                        ClusterTableObject.current.updateRow(ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"], {["SchTime"]:moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format('HH:mm')});
                        ClusterTableObject.current.updateRow(ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"], {["SchDateTime"]:moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format("YYYY-MM-DDTHH:mm:ss")});
                        ClusterTableObject.current.updateRow(ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"], {["EstTimeFromPrev"]:ARBResponseForStopViewComputeEstimates[i].EstTravelTime});
                        ClusterTableObject.current.updateRow(ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"], {["EstDistFromPrev"]:ARBResponseForStopViewComputeEstimates[i].EstTravelDistance});
                    }
                }
                if (_allRowsGrid2[k].Type == "EndDept") {
                    for (var i = 0; i < ARBResponseForStopViewComputeEstimates.length; i++) {
                        if (ARBResponseForStopViewComputeEstimates[i]["NodeType"] == "EndDept") {

                        ClusterTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "_" + _allRowsGrid2[k]["Type"], {["SchTime"]:moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format('HH:mm')});
                        ClusterTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "_" + _allRowsGrid2[k]["Type"], {["SchDateTime"]:moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format("YYYY-MM-DDTHH:mm:ss")});
                        ClusterTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "_" + _allRowsGrid2[k]["Type"], {["EstTimeFromPrev"]:ARBResponseForStopViewComputeEstimates[i].EstTravelTime});
                        ClusterTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "_" + _allRowsGrid2[k]["Type"], {["EstDistFromPrev"]:ARBResponseForStopViewComputeEstimates[i].EstTravelDistance});
                            
                        }
                    }
                }
                let _tempGridStopType = ClusterTableObject.current.getData()[k]?.Type;
                let _gridPrvSchTime = "00:00"
                let _gridPrvSchTimeInMinutes = 0;

                try {
                    _gridPrvSchTime = ClusterTableObject.current.getData()[k]?.SchTime;
                    if (_gridPrvSchTime != undefined){

                        _gridPrvSchTimeInMinutes = (parseInt(_gridPrvSchTime.split(':')[0]) * 60) + (parseInt(_gridPrvSchTime.split(':')[1]));
                    }
                } catch (b) {

                }

                let _gridSchTime = ClusterTableObject.current.getData()[k]?.SchTime;
                let _gridSchTimeInMinutes = 0;

                if (_gridSchTime != undefined){

                    _gridSchTimeInMinutes = (parseInt(_gridSchTime.split(':')[0]) * 60) + (parseInt(_gridSchTime.split(':')[1]));
                }
                

                if (_driverBreakStart != null && _tempGridStopType != "StartDept" && _tempGridStopType != "DriverBreakStart" && _tempGridStopType != "DriverBreakEnd") {
                    let _breakStartSchTime = _driverBreakStart.SchTime;
                    let _breakStartSchTimeInMinutes = (parseInt(_breakStartSchTime.split(':')[0]) * 60) + (parseInt(_breakStartSchTime.split(':')[1]));

                    if (_gridSchTimeInMinutes >= _breakStartSchTimeInMinutes && _gridPrvSchTimeInMinutes > _breakStartSchTimeInMinutes) {
                        ClusterTableObject.current.addRow(_driverBreakStart, true, _allRowsGrid2[k].Index);
                        _driverBreakStart = null;
                    }
                }
                if (_driverBreakEnd != null && _tempGridStopType != "StartDept" && _tempGridStopType != "DriverBreakStart" && _tempGridStopType != "DriverBreakEnd") {
                    let _breakEndSchTime = _driverBreakEnd.SchTime;
                    let _breakEndSchTimeInMinutes = (parseInt(_breakEndSchTime.split(':')[0]) * 60) + (parseInt(_breakEndSchTime.split(':')[1]));

                    if (_gridSchTimeInMinutes >= _breakEndSchTimeInMinutes && _gridPrvSchTimeInMinutes > _breakEndSchTimeInMinutes) {
                        ClusterTableObject.current.addRow(_driverBreakEnd, true, _allRowsGrid2[k].Index);
                        _driverBreakEnd = null;
                    }
                }

            }
            setclusterTableStateBeforeCompute(ClusterTableObject.current.getData());
           setTimeout(() => {
            ValidateRoute();
          }, 2000);
        }
        return () => {
        };
    }, [ARBResponseForStopViewComputeEstimates]);

    useEffect(() => {
        if(ARBResponseForStopViewValidate.length !== null && ClusterTableObject.current !== null){
           let originalTableData = ClusterTableObject.current.getData();
           for(let i = 0; i < originalTableData.length; i++){
            let _violationHtml = "";
                for(let j = 0; j < ARBResponseForStopViewValidate.length; j++){
                    if(originalTableData[i].Index === String(ARBResponseForStopViewValidate[j].TripNo +"_"+ ARBResponseForStopViewValidate[j].StopType) && 
                        ARBResponseForStopViewValidate[j].StopType !== 'DriverBreakStart'){
                        if (ARBResponseForStopViewValidate[j].ViolationID === -1) {
                            _violationHtml += '<span style="background-color: '+ violationColors[0].capacity +';margin: 2px;">CV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -2) {
                            _violationHtml += '<span style="background-color: '+ violationColors[0].timeWindow +';margin: 2px;">TWV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -3) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].RideTime +';margin: 2px;">RTV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -4) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].maxMilesHours +';margin: 2px;">MMV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -5) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].nonDrop +';margin: 2px;">NDV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -6) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].driverBreak +';margin: 2px;>DBV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -7) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].puLoopBack +';margin: 2px;">PLV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -8) {
                            _violationHtml += '<span style="background-color:#000000;margin: 2px;">TIV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -9) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].uniqueStops +';margin: 2px;">USV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -10) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].TripStartTime +';margin: 2px;">EST</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -11) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].maxRouteHrs +';margin: 2px;">RHV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -12) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].MaxTrips +';margin: 2px;">MTV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -13) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].invalidPUGPS +';margin: 2px;">PGPSV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -14) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].invalidDOGPS +';margin: 2px;">DGPSV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -15) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].WillCallTrip +';margin: 2px;">WCV</span>';
                        } else if (ARBResponseForStopViewValidate[j].ViolationID === -16) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].RideSharing +';margin: 2px;">RSV</span>';
                        }
                    }
                }
                if(originalTableData[i]['Type'] !== "StartDept" && originalTableData[i]['Type'] !== "IdleTime" && originalTableData[i]['Type'] !== "EndDept" ){
                    ClusterTableObject.current.updateRow(originalTableData[i]['Index'], {Violation: _violationHtml});
                }
            }
        }
        return () => {
        };
    }, [ARBResponseForStopViewValidate]);

    useEffect(() => {
        try{
            const PopulateAddBreakTripData = async(e) => {
                try{
                    if(StopViewBreakTrip !== null && ClusterTableObject.current !== null){
                        let index = StopViewBreakTrip.NextServiceTrip; 
                        ClusterTableObject.current.addRow(
                        {
                            Actions: StopViewBreakTrip.PUarray?.Action,
                            ['Passenger Load']: StopViewBreakTrip.PUarray['Passenger Load'],
                            bIsScheduled: StopViewBreakTrip.PUarray['bIsScheduled'],
                            EstTimeFromPrev: StopViewBreakTrip.PUarray['EstTimeFromPrev'],
                            bPerformed: StopViewBreakTrip.PUarray['bPerformed'],
                            bWillCall: StopViewBreakTrip.PUarray['bWillCall'],
                            CDDOStopNo: StopViewBreakTrip.PUarray['CDDOStopNo'],
                            CDName: StopViewBreakTrip.PUarray['CDName'],
                            CDPUStopNo: StopViewBreakTrip.PUarray['CDPUStopNo'],
                            ClusterType: StopViewBreakTrip.PUarray['ClusterType'],
                            dEarlyTimeWindow: StopViewBreakTrip.PUarray['dEarlyTimeWindow'],
                            dEstimateDistance: StopViewBreakTrip.PUarray['dEstimateDistance'],
                            dEstimatedTime: StopViewBreakTrip.PUarray['dEstimatedTime'],
                            dLateTimeWindow: StopViewBreakTrip.PUarray['dLateTimeWindow'],
                            dLatitude: StopViewBreakTrip.PUarray['dLatitude'],
                            dLongitude: StopViewBreakTrip.PUarray['dLongitude'],
                            dtActualDrop: StopViewBreakTrip.PUarray['dtActualDrop'],
                            dtActualPickup: StopViewBreakTrip.PUarray['dtActualPickup'],
                            dtDriverLoc: StopViewBreakTrip.PUarray['dtDriverLoc'],
                            Eta: StopViewBreakTrip.PUarray['Eta'],
                            dtReqIRTPU: StopViewBreakTrip.PUarray['dtReqIRTPU'],
                            EstDistFromPrev: StopViewBreakTrip.PUarray['EstDistFromPrev'],
                            ForcastedPUTime: StopViewBreakTrip.PUarray['ForcastedPUTime'],
                            ['Funding Source']: StopViewBreakTrip.PUarray['Funding Source'],
                            iAffiliateID: StopViewBreakTrip.PUarray['iAffiliateID'],
                            IdleTime: StopViewBreakTrip.PUarray['IdleTime'],
                            iID_RouteGeneralSettings: StopViewBreakTrip.PUarray['iID_RouteGeneralSettings'],
                            Index: StopViewBreakTrip.PUarray['Index'],
                            iRouteID: StopViewBreakTrip.PUarray['iRouteID'],
                            iScheduleID: StopViewBreakTrip.PUarray['iScheduleID'],
                            iTotalPassengerCount: StopViewBreakTrip.PUarray['iTotalPassengerCount'],
                            iTotalWheelChairs: StopViewBreakTrip.PUarray['iTotalWheelChairs'],
                            iVehStopOrder: StopViewBreakTrip.PUarray['iVehStopOrder'],
                            ManifestNumber: StopViewBreakTrip.PUarray['ManifestNumber'],
                            PUPerson: StopViewBreakTrip.PUarray['PUPerson'],
                            ReqTime: StopViewBreakTrip.PUarray['ReqTime'],
                            ReqTimeHidden: StopViewBreakTrip.PUarray['ReqTimeHidden'],
                            Route: StopViewBreakTrip.PUarray['Route'],
                            SchDateTime: StopViewBreakTrip.PUarray['SchDateTime'],
                            SchTime: StopViewBreakTrip.PUarray['SchTime'],
                            ServiceRequestType: StopViewBreakTrip.PUarray['ServiceRequestType'],
                            ['Stop#']: StopViewBreakTrip.PUarray['Stop#'],
                            TripNo: StopViewBreakTrip.PUarray['TripNo'],
                            StopStatus: StopViewBreakTrip.PUarray['StopStatus'],
                            Type: StopViewBreakTrip.PUarray['Type'],
                            vAddress: StopViewBreakTrip.PUarray['vAddress'],
                            vColor: StopViewBreakTrip.PUarray['vColor'],
                            VehicleInfo: StopViewBreakTrip.PUarray['VehicleInfo'],
                            Violation: StopViewBreakTrip.PUarray['Violation'],
                            vManifestDisposition: StopViewBreakTrip.PUarray['vManifestDisposition'],
                            VType: StopViewBreakTrip.PUarray['VType'],
                            Zone: StopViewBreakTrip.PUarray['Zone'],
                        }, true, index);
            
                        index =  StopViewBreakTrip.PUarray['Index'];  
                        ClusterTableObject.current.addRow(
                        {
                            Actions: StopViewBreakTrip.DOarray['Action'],
                            ['Passenger Load']: StopViewBreakTrip.DOarray['Passenger Load'],
                            bIsScheduled: StopViewBreakTrip.DOarray['bIsScheduled'],
                            EstTimeFromPrev: StopViewBreakTrip.DOarray['EstTimeFromPrev'],
                            bPerformed: StopViewBreakTrip.DOarray['bPerformed'],
                            bWillCall: StopViewBreakTrip.DOarray['bWillCall'],
                            CDDOStopNo: StopViewBreakTrip.DOarray['CDDOStopNo'],
                            CDName: StopViewBreakTrip.DOarray['CDName'],
                            CDPUStopNo: StopViewBreakTrip.DOarray['CDPUStopNo'],
                            ClusterType: StopViewBreakTrip.DOarray['ClusterType'],
                            dEarlyTimeWindow: StopViewBreakTrip.DOarray['dEarlyTimeWindow'],
                            dEstimateDistance: StopViewBreakTrip.DOarray['dEstimateDistance'],
                            dEstimatedTime: StopViewBreakTrip.DOarray['dEstimatedTime'],
                            dLateTimeWindow: StopViewBreakTrip.DOarray['dLateTimeWindow'],
                            dLatitude: StopViewBreakTrip.DOarray['dLatitude'],
                            dLongitude: StopViewBreakTrip.DOarray['dLongitude'],
                            dtActualDrop: StopViewBreakTrip.DOarray['dtActualDrop'],
                            dtActualPickup: StopViewBreakTrip.DOarray['dtActualPickup'],
                            dtDriverLoc: StopViewBreakTrip.DOarray['dtDriverLoc'],
                            Eta: StopViewBreakTrip.DOarray['Eta'],
                            dtReqIRTPU: StopViewBreakTrip.DOarray['dtReqIRTPU'],
                            EstDistFromPrev: StopViewBreakTrip.DOarray['EstDistFromPrev'],
                            ForcastedPUTime: StopViewBreakTrip.DOarray['ForcastedPUTime'],
                            ['Funding Source']: StopViewBreakTrip.DOarray['Funding Source'],
                            iAffiliateID: StopViewBreakTrip.DOarray['iAffiliateID'],
                            IdleTime: StopViewBreakTrip.DOarray['IdleTime'],
                            iID_RouteGeneralSettings: StopViewBreakTrip.DOarray['iID_RouteGeneralSettings'],
                            Index: StopViewBreakTrip.DOarray['Index'],
                            iRouteID: StopViewBreakTrip.DOarray['iRouteID'],
                            iScheduleID: StopViewBreakTrip.DOarray['iScheduleID'],
                            iTotalPassengerCount: StopViewBreakTrip.DOarray['iTotalPassengerCount'],
                            iTotalWheelChairs: StopViewBreakTrip.DOarray['iTotalWheelChairs'],
                            iVehStopOrder: StopViewBreakTrip.DOarray['iVehStopOrder'],
                            ManifestNumber: StopViewBreakTrip.DOarray['ManifestNumber'],
                            PUPerson: StopViewBreakTrip.DOarray['PUPerson'],
                            ReqTime: StopViewBreakTrip.DOarray['ReqTime'],
                            ReqTimeHidden: StopViewBreakTrip.DOarray['ReqTimeHidden'],
                            Route: StopViewBreakTrip.DOarray['Route'],
                            SchDateTime: StopViewBreakTrip.DOarray['SchDateTime'],
                            SchTime: StopViewBreakTrip.DOarray['SchTime'],
                            ServiceRequestType: StopViewBreakTrip.DOarray['ServiceRequestType'],
                            ['Stop#']: StopViewBreakTrip.DOarray['Stop#'],
                            TripNo: StopViewBreakTrip.DOarray['TripNo'],
                            StopStatus: StopViewBreakTrip.DOarray['StopStatus'],
                            Type: StopViewBreakTrip.DOarray['Type'],
                            vAddress: StopViewBreakTrip.DOarray['vAddress'],
                            vColor: StopViewBreakTrip.DOarray['vColor'],
                            VehicleInfo: StopViewBreakTrip.DOarray['VehicleInfo'],
                            Violation: StopViewBreakTrip.DOarray['Violation'],
                            vManifestDisposition: StopViewBreakTrip.DOarray['vManifestDisposition'],
                            VType: StopViewBreakTrip.DOarray['VType'],
                            Zone: StopViewBreakTrip.DOarray['Zone'],
                        }, true, index);
        
                        xCancelSourceForGrid.current = APICom.GenerateSource();
                        let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/Routing/AddManualBreakTrip", "post", {}, StopViewBreakTrip.input, xCancelSourceForGrid.current);
                        if(response.data[0].Result === "OK"){
                            let iRefID = response.data[0].iRefID;
                            ClusterTableObject.current.updateRow(StopViewBreakTrip.PUarray['Index'], {["TripNo"]:'0'+iRefID});
                            ClusterTableObject.current.updateRow(StopViewBreakTrip.DOarray['Index'], {["TripNo"]:'0'+iRefID});
                            ClusterTableObject.current.updateRow(StopViewBreakTrip.PUarray['Index'], {["Index"]:'0'+iRefID+'_DO'});
                            ClusterTableObject.current.updateRow(StopViewBreakTrip.DOarray['Index'], {["Index"]:'0'+iRefID+'_PU'});
                            setAddBreakModal({
                                isVisible: false
                                });
        
                            AdjustRouteTimes();
        
                            setTimeout(() => {
                                ValidateRoute();
                                CommitActions();
                                }, 2000);
            
                        }
                    }
                }
                catch(err){console.log(err);}
            }
            PopulateAddBreakTripData();
        }
        catch(err){console.log(err);}
        
        return () => {
        };
    }, [StopViewBreakTrip]);

    useEffect(() => {
        sidebarCheck.current = sidebarOpen;
    },[sidebarOpen]);

    useEffect(() => {
        checkboxSelectionFlag.current = showCompletedTrips;
    },[showCompletedTrips]);

    const GridLoadComplete = () => {
        try {
            setTimeTakenByLastGridCall((new Date()) - APICom.LastGridCall);  

            if (mapViewCheck.current){
                if(DropDownRouteValue.current && DropDownRouteValue.current != ""){
                    let DispatchGridData = mainTableObj.current.getData();
                    const singleMatchingRecord = DispatchGridData.find(item => item.Route === DropDownRouteValue.current);
    
                    if (singleMatchingRecord) {
                        if (singleMatchingRecord.Route != "" && someThingChangedInGrid.current == false){
                            handleClusterManifestData(singleMatchingRecord, checkboxSelectionFlag.current)
                            someThingChangedInGrid.current = false;
                        }
                    }
    
                }
                if(selectedTripInfoToRefreshGrid.current != null){
                    if (selectedTripInfoToRefreshGrid.current.Route != "" && someThingChangedInGrid.current == false){
                        handleClusterManifestData(selectedTripInfoToRefreshGrid.current, checkboxSelectionFlag.current)
                    }
                    else if (selectedTripInfoToRefreshGrid.current.Route == "" || selectedTripInfoToRefreshGrid.current.Route == null){
                        let autoDoubleClick = true

                        GridRowDoubleClick(selectedTripInfoToRefreshGrid.current, autoDoubleClick);
                    }
                }
            }

            
            
                
        }
        catch (err) { console.log(err); }
        
    
    }

    const AddBreakModalFunc = (starttime, dataArray) => {
        setAddBreakModal({
            isVisible: true,
            starttime: starttime.SchTime, // Pass the starttime to the modal
            tableData: dataArray,
            selectedRow : starttime
        });
    }
    
    const [height, setHeight] = useState(60);
    
    const ClusterGridheight = useRef(60);
    
    const handleRowResize = (newHeight) => {
        setHeight(newHeight);
        setIsResizing(true);
    }
    useEffect(() => {
        if(height !== 100){
            ClusterGridheight.current = height;
        }
    }, [height]);
    useEffect(() => {
        const selectedGroupingElm = document.querySelector('#gridgroupedcolstabulator');
        if (mapView) {
            
            setWidth(50);
            if(selectedGroupingElm)
            {
                selectedGroupingElm.style.width = '25px';
            }
        }
        else {
            if(selectedGroupingElm)
            {
                selectedGroupingElm.style.width = 'auto';
            }
            setWidth(100);
        }
    }, [mapView]);


    const verticalDragHandler = useCallback((e) => {
        let h =
        ((e.clientY -
            e.currentTarget.parentElement.parentElement.getBoundingClientRect()
            .top) /
            e.currentTarget.parentElement.parentElement.getBoundingClientRect()
            .height) *
        100;
        h = Math.min(h, 90);
        if (h > 0 && h !== height) {
        setHeight(h);
        }
    }, [height]);

    const horizontalDragHandler = useCallback(
        (e) => {
        let w =
            ((e.clientX -
            e.currentTarget.parentElement.parentElement.getBoundingClientRect()
                .left) /
            e.currentTarget.parentElement.parentElement.getBoundingClientRect()
                .width) *
                100;
            w = Math.min(w, 80);
            
        if (w > 0 && w !== width) {
            setWidth(w);
        }
        },
        [width]
    );
    
    const isFirefox = () => {
        return navigator.userAgent.toLowerCase().includes('firefox');
    };
    const DispatchGridControlRef = useRef();
    useEffect(() => {
        DispatchGridControlRef.current.SetWidth(width +"%");
    }, [width]);

    useEffect(() => {
        DispatchGridControlRef.current.SetGridRefreshPaused(GridRefreshPaused);
    }, [GridRefreshPaused]);


    const GridControlMemo = useMemo(() => 
        <GridControl setGroupingFilter={setGroupingHeaderFilter} rowColors={apiRowData} cellColors={apiColData} GridLoadComplete={GridLoadComplete} 
            AddBreakModalFunc={AddBreakModalFunc} setColumnChooser={setShowColumnChooser} showColumnChooser={showColumnChooser} persistentRowsSel={tableSelRows} 
            setPersistentRowSelection={setTableRowsSel} Data={[]} handleMapMode={setMapView} MapDetailData={MapDetailData} 
            ReloadDataFunction={PrepareGridRequest} setSelectedRowData={GridRowSelect} GridRefreshPaused =  {GridRefreshPaused}
             
            UseInternalGridDataReloadFunction={true}
            ref={DispatchGridControlRef}
            options={DispatchGridControlOptions} ShowLoader={ShowGridLoader} GridRowDoubleClick={GridRowDoubleClick} selectedRoute={SelectedRoute} width={width +"%"} 
        />, 
        [apiRowData,apiColData]);
    
    const handleSaveChanges = ()=>{

        if (modalActionType === 'adjustRouteStartTime') {

            let StopViewMainData = ClusterTableObject.current.getData();
            const time2 = routeStartTime;
            const time1 = ClusterTableObject.current.getData()[0].SchTime;
    
            const date1 = new Date(`1970-01-01T${time1}:00`);
            const date2 = new Date(`1970-01-01T${time2}:00`);
            let diffInMinutes = (date2.getTime() - date1.getTime()) / (1000 * 60);
    
            let originalDate = new Date(`1970-01-01T${StopViewMainData[0].SchTime}:00`);
            originalDate = new Date(originalDate.getTime() + diffInMinutes * 60000); 
            const newHours = originalDate.getHours().toString().padStart(2, '0');
            const newMinutes = originalDate.getMinutes().toString().padStart(2, '0');
            const newTime = `${newHours}:${newMinutes}`;
    
            ClusterTableObject.current.updateRow(StopViewMainData[0]['Index'], {SchTime: newTime});
    
            
            

        }

        else if (modalActionType === 'updateScheduleTime') {

            let StopViewMainData = ClusterTableObject.current.getData();
            const time2 = routeStartTime;
            const time1 = ClusterTableObject.current.getData().find(row => row.Index === StopViewSelectedRowIndex).SchTime;
    
            const date1 = new Date(`1970-01-01T${time1}:00`);
            const date2 = new Date(`1970-01-01T${time2}:00`);
            let diffInMinutes = (date2.getTime() - date1.getTime()) / (1000 * 60);
    
            let originalDate = new Date(`1970-01-01T${time1}:00`);
            originalDate = new Date(originalDate.getTime() + diffInMinutes * 60000); 
            const newHours = originalDate.getHours().toString().padStart(2, '0');
            const newMinutes = originalDate.getMinutes().toString().padStart(2, '0');
            const newTime = `${newHours}:${newMinutes}`;


            // Get the selected row and the update window
            const selectedRow = ClusterTableObject.current.getData().find(row => row.Index === StopViewSelectedRowIndex);
            const dUpdateSchWinMins = Math.round(selectedRow.dUpdateSchWinMins); // Round off the value

            let StopType = selectedRow.Type;
            // Get the ReqTime of the selected row
            let reqTime = "00:00";

            if(StopType.toLowerCase() === "pu"){
                reqTime = selectedRow.ReqTime;  // in time format like 13:12

            }

            else if(StopType.toLowerCase() === "do"){
                if (selectedRow && selectedRow.ReqTime && selectedRow.ReqTime.trim() !== ""){
                    reqTime = selectedRow.ReqTime;
                }
                else{
                const selectedPURowPU = ClusterTableObject.current.getData().find(row => row.TripNo ===  SelectedRowRefID.current && row.Type.toLowerCase()=== 'pu');
                const reqTimePU= selectedPURowPU.ReqTime; // in time format like 13:12
                const dEstimatedTime = selectedPURowPU.dEstimatedTime; //in minutes like 45
                const ServiceTime = selectedPURowPU.ServiceTime; // in minutes like 15


                // Convert reqTimePU (which is in time format "HH:mm") to a Date object
                const [hours, minutes] = reqTimePU.split(":").map(Number);
                const date = new Date();
                date.setHours(hours, minutes);

                // Add dEstimatedTime and serviceTime (both in minutes)
                date.setMinutes(date.getMinutes() + dEstimatedTime + ServiceTime);

                // Format the new time in "HH:mm" format
                const formattedTime = date.toTimeString().slice(0, 5); // Extracts "HH:mm" part

                reqTime = formattedTime; // This will be in "HH:mm" format

                }
                

            }


            // Calculate the acceptable range using ReqTime and dUpdateSchWinMins
            const lowerBound = new Date(`1970-01-01T${reqTime}:00`);
            lowerBound.setMinutes(lowerBound.getMinutes() - dUpdateSchWinMins); // Subtract update window for lower bound

            const upperBound = new Date(`1970-01-01T${reqTime}:00`);
            upperBound.setMinutes(upperBound.getMinutes() + dUpdateSchWinMins); // Add update window for upper bound

            // Format bounds for comparison
            const lowerBoundTime = `${lowerBound.getHours().toString().padStart(2, '0')}:${lowerBound.getMinutes().toString().padStart(2, '0')}`;
            const upperBoundTime = `${upperBound.getHours().toString().padStart(2, '0')}:${upperBound.getMinutes().toString().padStart(2, '0')}`;

            // Format time into AM/PM format
            const formatAMPM = (date) => {
                let hours = date.getHours();
                let minutes = date.getMinutes();
                const ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                const strTime = `${hours}:${minutes} ${ampm}`;
                return strTime;
            };

            // Check if newTime is within the acceptable range
            if (newTime < lowerBoundTime || newTime > upperBoundTime) 
                {
                    setValidationError(true);
                    setErrorMessageUST(`Time should be between ${formatAMPM(lowerBound)} and ${formatAMPM(upperBound)}`);
                    return;
                }

            setValidationError(false);
            setErrorMessageUST('');

            const fromtime = new Date(`1970-01-01T${time1}:00`);
            const toTime = new Date(`1970-01-01T${newTime}:00`);

            HistoryReason.current= `${StopType} Schedule Time is updated manually from ${formatAMPM(fromtime)} to  ${formatAMPM(toTime)}`

            ClusterTableObject.current.updateData([{ Index: StopViewSelectedRowIndex, SchTime: newTime }]);
        }

        AdjustRouteTimes()

        setEditRouteTimeModal(false)

       

        // for (let i = 0; i < StopViewMainData.length; i++) {
        //     let originalDate = new Date(`1970-01-01T${StopViewMainData[i].SchTime}:00`);
        //     originalDate = new Date(originalDate.getTime() + diffInMinutes * 60000); 
        //     const newHours = originalDate.getHours().toString().padStart(2, '0');
        //     const newMinutes = originalDate.getMinutes().toString().padStart(2, '0');
        //     const newTime = `${newHours}:${newMinutes}`;

        //     if (StopViewMainData[i]['Type'] == "IdleTime") {
        //         let idleTime = StopViewMainData[i]['IdleTime'];
        //         let newIdleTime = idleTime - diffInMinutes; 

        //         if (newIdleTime > 0) {
        //             ClusterTableObject.current.updateRow(StopViewMainData[i]['Index'], {
        //                 IdleTime: newIdleTime,
        //                 SchTime: newTime
        //             });
        //             break;
        //         } else {
        //             ClusterTableObject.current.deleteRow(StopViewMainData[i]['Index']);
        //             diffInMinutes += newIdleTime;
        //         }
        //     } else {
        //         ClusterTableObject.current.updateRow(StopViewMainData[i]['Index'], {SchTime: newTime});
        //     }
        // }

        // ValidateRoute();
        // setTimeout(() => {
        //     setEditRouteTimeModal(false);
        // }, 1000);

    }

    const handleCancelUST = () => {
        setValidationError(false);
        setErrorMessageUST('');
        setEditRouteTimeModal(false);
      };
    
    const handleRouteAlertClose = () => {
        setAlert(false);
    };

    const handleRoutingAlertClose = () =>{
        setRouteAlert(false);
    };

    const handleSRProgressBar = () => {
        sethandlePageProgressBar("dispatch");
    };


    return (
        <div>  
            
       <style dangerouslySetInnerHTML={{ __html: DynamicsStyles }}> 
       </style>          
            <ARBResponseListener GridRefresh={PrepareGridRequest} showClusteringDialog={showClusteringDialog}  handlePageProgressBar={handlePageProgressBar}
                setShowClusterDialog={setShowClusterDialog} setManifestBuildDialog={setManifestBuildDialog} setAlert = {setAlert}  setRouteSuggestionActionCreate={setRouteSuggestionActionCreate}
                StopViewGridLoad={() => StopViewGridLoad(_vManifestNumber.current, _iAffilaiteID.current)} 
                />
            <DispatchMainToolbar setNullifyActivated={setNullifyActivated} nullifyActivated={nullifyActivated} 
                setDetailDataFunc={setClusterGridResponse} setSelectedRoute={handleSelectedRouteChange} setDropDownRoute = {handleDropDownRouteChange}
                setSideBarStatus={setSidebarOpen} NetworkTimeTakenByLastGridCall={NetworkTimeTakenByLastGridCall} 
                TimeTakenByLastGridCall={TimeTakenByLastGridCall} ToolBoxStateChange={ToolBoxStateChange} 
                options={DispatchGridControlOptions} setGroupingFilter={setGroupingHeaderFilter} handleMapMode={setMapView} initiateCancel={setShowCancel} 
                setShowTripActionsDialog={handleTripActionsDialogueShowHide} 
                setDriverActionsDialog={setDriverActionsDialog} setShowClusterDialog={setShowClusterDialog} setShowGroupingActionDialog={setShowGroupingActionDialog}
                initiateActivate={setShowActivateDialog} initiateVehicleTracking={setShowVehicleTracking} initiateUpdateCallback={setShowUpdateCallback}
                setTripHistoryDialog={setTripHistoryDialog} setBrokerActionsDialog={setBrokerActionsDialog} initiateAgileDispatch={setShowAgileDispatch}
                setManifestBuildDialog={setManifestBuildDialog} setShowRoutesDialog={setShowRoutesDialog} setStandingRouteDialog={setStandingRouteDialog} 
                setAgentNotesDialog={setAgentNotesDialog} GridRowData={selectRowData} setMTDiagnosticDialog = {setMTDiagnosticDialog}
                setRBSProcessDialog={setRBSProcessDialog} setCheckCompletedTrips={setShowCompletedTrips} mainSelectedRow={selectedTripInfo.current} 
                handleClusterReload={handleClusterManifestData} setTripDetailsDialog={setTripDetailsDialog} selectedAffiliates={ToolboxValues.AffiliatesList} 
                selectedDate={ToolboxValues.Date} selectedRoute={SelectedRoute} setSettings ={setClusterGridColumnSetting}  setRouteSuggestionActionCreate={setRouteSuggestionActionCreate}
                handleMapHeight={ handleRowResize} selectedTripInfoToRefreshGrid = {selectedTripInfoToRefreshGrid} DropDownRouteValue = {DropDownRouteValue}
                vehData = {vehData} updateVehData={setVehData} isFromDoubleClick={MapViewFromDoubleClick} setIsFromDoubleClick={setMapViewFromDoubleClick}
                
            />
            
            <div className='row' style={{ margin: '0px' , height: `calc(100vh - 145px)`}}>
                {GridControlMemo}
                {showCancel ? <CancelTrip GridRowData={selectRowData} showCancel={showCancel} setShowCancel={setShowCancel} /> : ""}
                <div     
                            style={{
                                display: 'flex',
                                margin: '0',
                                background: '#32728b',
                                cursor: 'col-resize',
                                width: '5px',
                                padding: '0'
                            }}
                            draggable
                            onDrag={isFirefox() ? undefined: horizontalDragHandler}
                            onDragEnd={isFirefox() ? horizontalDragHandler : undefined}
                            className="col-1 flex justify-center items-center bg-slate-800 cursor-col-resize"
                        >  
                        </div>
                <div className='col-5' style={{
                    padding: '0px', flex: '1',
                    width: sidebarOpen? `calc(${100 - width - 10}% - 5px)` : `calc(${100 - width}% - 5px)`,
                    height: '100%',
                    display: mapView ? 'block' : 'none',
                    }}>
                    <div className='row' style={{ height: '100%', margin: '0' }}>

                        {mapView  ? 
                            <MapControl setNullifyActivated={setNullifyActivated} sidebarStatus={sidebarCheck.current} 
                                clusterTripSelected={clusterTripSelection} unroutedTrip={unroutedTripShow.current} routedTrip={routedTripShow.current} 
                                arrangedTripsClusterData={arrangedClusterTrips} selectedTripInfoToRefreshGrid = {selectedTripInfoToRefreshGrid}
                                selectedAffiliates={ToolboxValues.AffiliatesList} options={DispatchGridControlOptions} DropDownRouteValue={DropDownRouteValue}
                                zones={ZoneVerticesData.Table} handleMapMode={setMapView} selectedDate={ToolboxValues.Date} 
                                GridRowData={selectRowData} setDetailDataFunc={setClusterGridResponse} MapDetailData={ClusterGridResponse} vehData={vehData}
                                DispatchDriverData={DispatchDriverData} DispatchVehicleData={DispatchVehicleData} GridRefresh={PrepareGridRequest} height={height + "%"} 
                                handleMapHeight={ handleRowResize} clusterTableStateBeforeCompute={clusterTableStateBeforeCompute} SelectedStopsData= {SelectedStopsData}
                                isGridRefreshed = {someThingChangedInGrid.current} isFromDoubleClick={MapViewFromDoubleClick} setIsFromDoubleClick={setMapViewFromDoubleClick}
                            /> 
                        : ""}
                        <div     
                            style={{
                                display: isResizing  ? 'flex' : 'none',
                                width: '100%',
                                margin: '0',
                                height: '5px',
                                cursor: 'row-resize',
                                background: '#32728b',
                                padding: '0'
                            }}
                            draggable
                            onDrag={isFirefox() ? undefined: verticalDragHandler}
                            onDragEnd={isFirefox() ? verticalDragHandler : undefined}
                            className="row flex justify-center items-center h-1/6 bg-slate-800 cursor-col-resize"
                        >
                        </div>
                        {mapView ? 
                            <GridControl setArrangedClusterTripsFunc={setArrangedClusterTripsFunc} 
                                ShowLoader={ShowGridClusterLoader}  MapDetailData={ClusterGridResponse} handleMapMode={setMapView}  AddBreakModalFunc={AddBreakModalFunc}
                                Data={ClusterGridResponse} options={ClusterGridControlOptions} ReloadDataFunction={handleClusterGridResponse} 
                                GridColumnSetting={ClusterGridColumnSetting}
                                height={(100 - height) +"%"} setRowMoveFlag = {setRowMoveFlag}
                            /> 
                        : ""}
                    </div>
                </div>
            </div>
            
            {/* {mapView ? <GridControl getArrangedClusterTrips={getArrangedClusterTrips} Data={ClusterGridResponse} MapDetailData={MapDetailData} 
            ReloadDataFunction={PrepareGridRequest} setSelectedRowData={GridRowSelect} options={ClusterGridControlOptions} GridRowDoubleClick={GridRowDoubleClick} />: ""} */}

            {showActivateDialog ? <ActivateTrip GridRowData={selectRowData} showActivateDialog={showActivateDialog} setShowActivateDialog={setShowActivateDialog}  /> : "" }
            {/* {showEditDialog ? <EditTrip GridRowData={selectRowData} showEditDialog={showEditDialog} setShowEditDialog={setShowEditDialog}  /> : "" } */}
            {showTripActionsDialog ? <TripActions triggerUnAssign={triggerUnAssign} setTriggerUnAssign={setTriggerUnAssign} GridRowData={selectRowData} showTripActionsDialog={showTripActionsDialog} 
            setShowTripActionsDialog={setShowTripActionsDialog}  ReloadDataFunction={PrepareGridRequest} setGridRefreshPaused= {setGridRefreshPaused}/> : "" }
            {showDriverActionsDialog ? <DriverActionsDialog AffiliateIDList={ToolboxValues.AffiliatesList} GridRowData={selectRowData} showDriverActionsDialog={showDriverActionsDialog} setDriverActionsDialog={setDriverActionsDialog} ReloadDataFunction={PrepareGridRequest}  /> : "" }
            {showGroupingDialog ? <GroupingActions groupingSet={mainTableObj.current.getData('active')} GridRowData={selectRowData} showGroupingDialog={showGroupingDialog} setShowGroupingActionDialog={setShowGroupingActionDialog} GridRefresh={PrepareGridRequest}  /> : "" }
            {showClusteringDialog ? 
                <BuildCluster triggerUnRoute={triggerUnRoute} setTriggerUnRoute={setTriggerUnRoute} GridRowData={selectRowData} addTripRoute={route} 
                    setAddtoRoute={setAddTripToRouteCluster} addtoRoute={addTripToRouteCluster} showClusteringDialog={showClusteringDialog} 
                    setShowClusterDialog={setShowClusterDialog} GridRefresh={PrepareGridRequest} selectedDate={ToolboxValues.Date} selectedAffiliates={ToolboxValues.AffiliatesList}  
                /> 
            : "" }
            {showVehicleTracking ? <VehicleTracking GridRowData={selectRowData} showVehicleTracking={showVehicleTracking} setShowVehicleTracking={setShowVehicleTracking} /> : ""}
            {showUpdateCallback ? <UpdateCallback GridRowData={selectRowData} showUpdateCallback={showUpdateCallback} setShowUpdateCallback={setShowUpdateCallback} /> : ""}
            {showTripHistoryDialog ? <TripHistoryDialog GridRowData={selectRowData} showTripHistoryDialog={showTripHistoryDialog} setTripHistoryDialog={setTripHistoryDialog}  /> : "" }
            {showBrokerActionsDialog ? <BrokerActionsDialog GridRowData={selectRowData} showBrokerActionsDialog={showBrokerActionsDialog} setBrokerActionsDialog={setBrokerActionsDialog} 
             ReloadDataFunction={PrepareGridRequest} numOfTripsInRoute = {numOfTripsInRoute} setGridRefreshPaused = {setGridRefreshPaused}/> : "" }
            {showAgileDispatch  ? <AgileDispatch UnMountFunction={UnMountAgileDispatch} GridRowData={selectRowData} showAgileDispatch={showAgileDispatch} setShowAgileDispatch={setShowAgileDispatch}  ReloadDataFunction={PrepareGridRequest} /> : ""}
            {showModal ? <ConfirmationModal show={DispatchScreenModalProps.show}  Title={DispatchScreenModalProps.Title}  Body={DispatchScreenModalProps.Body}  btnCanceText={DispatchScreenModalProps.btnCanceText}  btnOkText={DispatchScreenModalProps.btnOkText} ShowCancelButton={DispatchScreenModalProps.ShowCancelButton} onOk={handleCloseModal}  /> : "" }
            {showTripDetailsDialog ? <TripDetailsDialog GridRowData={selectRowData} showTripDetailsDialog={showTripDetailsDialog} setTripDetailsDialog={setTripDetailsDialog}  /> : "" }
            {showManifestBuildDialog ? 
                <BuildManifest triggerRouteSuggestion={triggerRouteSuggestion} settriggerRouteSuggestion={settriggerRouteSuggestion} triggerUnRoute={triggerUnRoute} setTriggerUnRoute={setTriggerUnRoute} GridRowData={selectRowData} 
                    addTripRoute={route} setAddtoRoute={setAddTripToRoute} addtoRoute={addTripToRoute} showManifestBuildDialog={showManifestBuildDialog} 
                    setManifestBuildDialog={setManifestBuildDialog} GridRefresh={PrepareGridRequest} selectedDate={ToolboxValues.Date}  setRouteSuggestionActionCreate= {setRouteSuggestionActionCreate} 
                    selectedAffiliates={ToolboxValues.AffiliatesList}  
                /> 
            : "" }

            
            {showRouteSuggestionActionCreate ? <RunRouteSuggestion GridRefresh={PrepareGridRequest} GridRowData={selectRowData} showRouteSuggestionActionCreate={showRouteSuggestionActionCreate} 
            setRouteSuggestionActionCreate={setRouteSuggestionActionCreate} disbaleButton={setdisableAllButtons} selectedDate={ToolboxValues.Date} selectedAffiliates={ToolboxValues.AffiliatesList}/> : ""}

            
            {showRoutesDialog ? <ShowRoutes GridRowData={selectRowData} showRoutesDialog={showRoutesDialog} setShowRoutesDialog={setShowRoutesDialog} GridRefresh={PrepareGridRequest} selectedAffiliates={ToolboxValues.AffiliatesList} selectedDate={ToolboxValues.Date}/>:""}
            {showRBSProcessDialog ? <RBSProcess GridRowData={selectRowData} showRBSProcessDialog={showRBSProcessDialog} setRBSProcessDialog={setRBSProcessDialog} GridRefresh={PrepareGridRequest} selectedDate={ToolboxValues.Date} selectedAffiliates={ToolboxValues.AffiliatesList}  /> : "" }
            {showStandingRouteDialog ? <StandingRoutes selectedAffiliates={ToolboxValues.AffiliatesList} selectedDate={ToolboxValues.Date} 
                showStandingRouteDialog={showStandingRouteDialog}  setStandingRouteDialog={setStandingRouteDialog} setSRProgressBar = {handleSRProgressBar}/>:""}


            {showAddBreakModal.isVisible  ? <AddBreakModal showAddBreakModal={showAddBreakModal} setAddBreakModal={setAddBreakModal}/>:""}
            
            {showAgentNotesDialog ? <AgentNotesDialog GridRowData={selectRowData} showAgentNotesDialog={showAgentNotesDialog} setAgentNotesDialog={setAgentNotesDialog}  /> : "" }
            {/* {showColumnChooser ? <ColumnChooser options={DispatchGridControlOptions} mainTableObj={mainTableObj.current} showColumnChooser={showColumnChooser} setColumnChooser={setShowColumnChooser}/>: ""} */}
            {showDynamicModal ? 
                <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowDynamicModal(false)} show={showDynamicModal} animation={true}>
                    <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                        <Modal.Title className='text-white'>{modalHeaderText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{modalBodyHTML}</Modal.Body>
                    <Modal.Footer>
                        {modalBtnHTML}
                    </Modal.Footer>
                </Modal>
            : ""}

            {showMTDiagnosticDialog ? <MTDiagnostic   showMTDiagnosticDialog={showMTDiagnosticDialog} setMTDiagnosticDialog={setMTDiagnosticDialog} selectedAffiliates={ToolboxValues.AffiliatesList} /> : "" }
            
           


            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} 
                btnCancelText={confirmationModalObj.btnCancelText}
                btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="false"  />

                <Modal show={showEditRouteTimeModal ? 1 : 0} centered backdrop="static" animation={true} onHide={handleCancelUST} keyboard={true} size="md" aria-labelledby="contained-modal-title-vcenter">
                    <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
                    <Modal.Title className='dispatch_action_dialog_title_color user-select-none'>
                        Edit Schedule Time
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="grid-example">
                    <div className="form-row">
                        <div className="form-group col-md-6">
                        <label htmlFor="startTime">Stop Schedule Time</label>
                        <input type="time" className="form-control" id="startTime" value={routeStartTime} onChange={(e) => setRouteStartTime(e.target.value)}  />
                        </div>
                        {validationError && (
                            <div className="form-group">
                                <span style={{ color: 'red', fontSize: '12px' }}>
                                {errorMessageUST}
                                </span>
                            </div>
                        )}
                    </div>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button className="activate_btn_ok border-0"  onClick={handleSaveChanges}>Save Changes</Button>
                    <Button className="activate_btn_ok border-0" onClick={handleCancelUST}>Cancel</Button>
                    </Modal.Footer>
                </Modal>

                {showAlert && <Modal centered keyboard={false} show={showAlert} backdrop="static" animation={true} onHide={handleRouteAlertClose} >
                <Modal.Header>
                    <Modal.Title>{routeObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{routeObj.alertMsg}</b></Modal.Body>
                {routeObj.displayFooter?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleRouteAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                :""}
            </Modal>}

            {showRouteAlert && <Modal centered show={showRouteAlert} onHide={handleRoutingAlertClose} >
                <Modal.Header closeButton>
                    <Modal.Title>{routeAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{routeAlertObj.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleRoutingAlertClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            </div>

       
    );
};

export default DispatchComponent;
